import type { Translations } from './types';

const de: Translations = {
  nav: {
    approvals: 'Freigaben',
    home: 'Startseite',
    search: 'Suchen',
    dashboard: 'Dashboard',
    outdoors: 'Werbeflächen',
    campaigns: 'Kampagnen',
    admin: 'Admin',
    logIn: 'Anmelden',
    signUp: 'Registrieren',
    logOut: 'Abmelden',
    account: 'Konto',
    setupBusiness: 'Unternehmen einrichten',
    searchOutdoors: 'Werbeflächen suchen',
    manageOutdoors: 'Werbeflächen verwalten',
    verifyOutdoors: 'Werbeflächen verifizieren',
    adminPanel: 'Administrationsbereich',
    upcomingCampaigns: 'Bevorstehende Kampagnen',
    getPaid: 'Bezahlung Erhalten',
    revenue: 'Einnahmen',
    payments: 'Zahlungen',
  },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    back: 'Zurück',
    next: 'Weiter',
    done: 'Fertig',
    loading: 'Lädt…',
    error: 'Etwas ist schiefgelaufen',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    clear: 'Zurücksetzen',
    edit: 'Bearbeiten',
    add: 'Hinzufügen',
    search: 'Suchen',
    view: 'Ansehen',
    create: 'Erstellen',
    update: 'Aktualisieren',
    submit: 'Absenden',
    yes: 'Ja',
    no: 'Nein',
    close: 'Schließen',
    upload: 'Hochladen',
    uploading: 'Wird hochgeladen…',
    saving: 'Wird gespeichert…',
    creating: 'Wird erstellt…',
    noResults: 'Keine Ergebnisse',
    required: 'Pflichtfeld',
    optional: 'Optional',
    copy: 'Kopieren',
    copied: 'Kopiert!',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    page: 'Seite',
    of: 'von',
    perDay: '/Tag',
    days: '{{count}} Tag',
    days_plural: '{{count}} Tage',
    termsAndConditions: 'AGB',
    selectCountry: 'Land auswählen...',
    noCountriesFound: 'Kein Land gefunden',
    notSet: 'Nicht festgelegt',
    showPassword: 'Passwort anzeigen',
    hidePassword: 'Passwort verbergen',
    refresh: 'Aktualisieren',
    new: 'Neu',
    rowsPerPage: 'Zeilen pro Seite',
  },
  home: {
    tagline: 'Ihr sichtbarkeitsgetriebener OOH-Marktplatz',
    heroTitle: 'Ihre Marke erreicht neue Höhen',
    heroSubtitle:
      'Scapow verbindet Plakatbesitzer mit Werbetreibenden. Erkunden Sie echte Werbeflächen, planen Sie Kampagnen und erreichen Sie Ihr Publikum - alles an einem Ort.',
    browseOutdoors: 'Werbeflächen erkunden',
    getStartedFree: 'Kostenlos starten',
    featuredOutdoors: 'Ausgewählte Werbeflächen',
    viewAll: 'Alle anzeigen →',
    howItWorksTitle: 'So funktioniert es',
    howItWorksSubtitle: 'Drei einfache Schritte, um Ihre Botschaft vor das richtige Publikum zu bringen.',
    step1Title: 'Den perfekten Platz finden',
    step1Desc:
      'Suchen Sie Werbeflächen nach Standort, Größe und Preis. Filtern Sie nach Verfügbarkeit für Ihre Kampagnendaten.',
    step2Title: 'Kampagne erstellen',
    step2Desc:
      'Fügen Sie mehrere Werbeflächen zu einer Kampagne hinzu, laden Sie Ihre Werbemittel hoch und erhalten Sie Zahlungsdetails.',
    step3Title: 'Ergebnisse verfolgen',
    step3Desc:
      'Überwachen Sie den Kampagnenfortschritt, den Bannerstatus und Leistungskennzahlen in Ihrem Dashboard.',
    builtTitle: 'Für beide Seiten gemacht',
    builtSubtitle:
      'Ob Sie Werbeflächen besitzen oder werben möchten – Scapow hat die Lösung für Sie.',
    feature1Title: 'Werbeflächen auflisten',
    feature1Desc:
      'Erstellen Sie ganz einfach Angebote, legen Sie Preise fest, fügen Sie Fotos hinzu und steuern Sie die Verfügbarkeit.',
    feature2Title: 'Kartenbasierte Suche',
    feature2Desc:
      'Finden Sie Werbeflächen auf einer Live-Karte. Zoomen Sie rein für kleineren Radius, raus für größere Reichweite.',
    feature3Title: 'Kampagnenmanagement',
    feature3Desc:
      'Erstellen Sie Kampagnen mit mehreren Werbeflächen, laden Sie Werbemittel hoch und zahlen Sie per Banküberweisung.',
    feature4Title: 'Verifizierte Unternehmen',
    feature4Desc: 'Alle Unternehmen werden mit Firmendokumenten verifiziert, bevor sie live gehen.',
    feature5Title: 'Leistungsverfolgung',
    feature5Desc:
      'Werbetreibende und Anbieter erhalten Dashboard-Übersichten über Einnahmen und Aktivitäten.',
    feature6Title: 'Transparente Preise',
    feature6Desc: 'Anbieterpreise pro Tag angezeigt - immer sichtbar vor der Bestätigung.',
    ctaTitle: 'Bereit loszulegen?',
    ctaSubtitle: 'Treten Sie Scapow heute bei und verbinden Sie sich mit dem Außenwerbemarkt.',
    createAccount: 'Konto erstellen',
    browseFirst: 'Erst erkunden',
    nearbyOutdoors: 'Werbeflächen in Ihrer Nähe',
    detectingLocation: 'Standort wird ermittelt…',
    basedOnLocation: 'Basierend auf Ihrem aktuellen Standort',
    welcomeBack: 'Willkommen, {{name}}',
    fromCompany: 'von {{company}}',
    ppPrompt: 'Sind alle Ihre Werbeflächen bereit für neue Kampagnen?',
    advertiserPrompt: 'Sind Sie bereit, Kampagnen zu erstellen?',
    noCompanyPrompt: 'Richten Sie Ihr Unternehmen ein, um alle Funktionen freizuschalten.',
    goToDashboard: 'Zum Dashboard',
    inviteFrom: '{{company}} hat Sie eingeladen, ihrem Team bei Scapow beizutreten.',
    inviteFromDesc: 'Nehmen Sie an, um mit ihnen an Außenwerbungskampagnen zusammenzuarbeiten.',
    inviteAccept: 'Einladung annehmen',
    inviteDecline: 'Ablehnen',
    inviteAccepted: 'Herzlich willkommen! Sie sind {{company}} erfolgreich beigetreten.',
    inviteDeclined: 'Sie haben die Einladung abgelehnt.',
    ppHowItWorksSubtitle: 'Alles, was Sie brauchen, um Ihre Werbeflächen in eine stetige Einnahmequelle zu verwandeln.',
    ppStep1Title: 'Präsentieren Sie Ihre Flächen',
    ppStep1Desc: 'Listen Sie Ihre Werbeflächen mit ansprechenden Fotos, genauen Maßen und wettbewerbsfähigen Preisen - damit Werbetreibende ihren Wert sofort erkennen.',
    ppStep2Title: 'Von Marken entdeckt werden',
    ppStep2Desc: 'Ihre Flächen erscheinen in den Suchanfragen von Werbetreibenden, die ihre nächste Kampagne planen. Die richtige Kampagne findet Sie.',
    ppStep3Title: 'Nachweis erbringen und kassieren',
    ppStep3Desc: 'Laden Sie Fotobeweise hoch, sobald Ihre Werbefläche aufgestellt und in Betrieb ist. Die Zahlung wird nach Genehmigung automatisch verarbeitet.',
  },
  auth: {
    login: {
      heroTitle: 'Verbinden Sie Ihre Marke mit der Welt. Eine neue Höhe nach der anderen.',
      heroSubtitle:
        'Die Plattform, die Plakatbesitzer mit Werbetreibenden verbindet – einfach, schnell und wirkungsvoll.',
      title: 'Willkommen zurück',
      subtitle: 'Melden Sie sich an, um fortzufahren',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      forgotPassword: 'Passwort vergessen?',
      resendVerification: 'Verifizierungs-E-Mail erneut senden',
      signIn: 'Anmelden',
      noAccount: 'Noch kein Konto?',
      createOne: 'Jetzt erstellen',
      invalidCredentials: 'Ungültige E-Mail oder Passwort. Bitte versuchen Sie es erneut.',
    },
    register: {
      heroTitle: 'Nehmen Sie an der Revolution der Außenwerbung teil',
      heroSubtitle:
        'Ob Plakatbesitzer oder Werbetreibender – Scapow macht es einfach.',
      title: 'Konto erstellen',
      subtitle: 'Beginnen Sie noch heute mit der Verwaltung von Außenwerbekampagnen',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail-Adresse',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      passwordHint: 'Mindestens 8 Zeichen',
      createAccount: 'Konto erstellen',
      alreadyHaveAccount: 'Bereits ein Konto?',
      signIn: 'Anmelden',
      checkEmail: 'Überprüfen Sie Ihre E-Mail',
      checkEmailDesc:
        'Wir haben einen Bestätigungslink an Ihre E-Mail-Adresse gesendet. Klicken Sie darauf, um Ihr Konto zu aktivieren.',
      goToLogin: 'Zur Anmeldung',
      termsAgreement: 'Ich habe die AGB gelesen und stimme zu',
      termsLink: 'AGB',
    },
    forgotPassword: {
      title: 'Passwort zurücksetzen',
      subtitle: 'Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Reset-Link',
      email: 'E-Mail-Adresse',
      sendReset: 'Reset-Link senden',
      backToLogin: 'Zurück zur Anmeldung',
      checkEmail: 'Überprüfen Sie Ihre E-Mail',
      checkEmailDesc:
        'Falls diese Adresse registriert ist, erhalten Sie in Kürze einen Reset-Link.',
    },
    resetPassword: {
      title: 'Neues Passwort festlegen',
      subtitle: 'Wählen Sie ein sicheres Passwort, das Sie sich merken können.',
      newPassword: 'Neues Passwort',
      confirmPassword: 'Passwort bestätigen',
      save: 'Neues Passwort speichern',
      submit: 'Passwort aktualisieren',
    },
    verifyEmail: {
      verifying: 'E-Mail wird verifiziert…',
      success: 'E-Mail verifiziert!',
      successDesc: 'Ihr Konto ist jetzt aktiv. Sie können sich anmelden.',
      error: 'Verifizierung fehlgeschlagen',
      errorDesc: 'Der Link ist möglicherweise abgelaufen oder ungültig. Bitte registrieren Sie sich erneut.',
      goToLogin: 'Zur Anmeldung',
      successDescBusiness: 'Ihr Konto ist jetzt aktiv. Sie können sich anmelden und Ihr Unternehmen einrichten.',
      returnToLogin: 'Zurück zur Anmeldung',
      resendButton: 'Neuen Verifizierungslink anfordern',
    },
    resendVerification: {
      title: 'Verifizierungs-E-Mail erneut senden',
      subtitle: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen neuen Verifizierungslink.',
      email: 'E-Mail-Adresse',
      send: 'Verifizierungs-E-Mail senden',
      backToLogin: 'Zurück zur Anmeldung',
      checkEmail: 'Prüfen Sie Ihre E-Mails',
      checkEmailDesc: 'Falls Ihr Konto auf Verifizierung wartet, haben wir Ihnen einen neuen Link in Ihren Posteingang gesendet.',
    },
  },
  business: {
    pendingVerification: 'Ihr Unternehmenskonto wird derzeit geprüft. Sobald unser Team die Validierung abgeschlossen hat, haben Sie uneingeschränkten Zugang zu allen Scapow-Funktionen. Bitte behalten Sie Ihren Posteingang im Auge - wir könnten uns melden, falls weitere Unterlagen erforderlich sind.',
    setup: {
      title: 'Unternehmen einrichten',
      subtitle: 'Verknüpfen Sie Ihr Konto mit einer Geschäftseinheit, um Scapow zu nutzen.',
      ppTitle: 'Flächenanbieter',
      ppDesc: 'Ich besitze Außenwerbeflächen und möchte sie vermieten.',
      advertiserTitle: 'Werbetreibender',
      advertiserDesc: 'Ich möchte Außenwerbekampagnen buchen.',
      changeType: 'Ändern ↩',
      createCompany: 'Neues Unternehmen erstellen',
      createCompanyDesc: 'Registrieren Sie Ihr Unternehmen bei Scapow.',
      joinCompany: 'Bestehendem Unternehmen beitreten',
      joinCompanyDesc: 'Beantragen Sie Zugang zu einem bereits registrierten Unternehmen.',
      registerTitle: 'Unternehmen registrieren',
      companyName: 'Unternehmensname',
      vatNumber: 'USt-IdNr.',
      companyEmail: 'Unternehmens-E-Mail',
      currency: 'Bevorzugte Währung',
      currencyHint: 'ISO-Währungscode, z.B. EUR, USD, GBP',
      country: 'Land',
      proofDocument: 'Nachweis des Unternehmens',
      proofHint: 'PDF, JPG oder PNG',
      uploadProof: 'Klicken, um Unternehmensnachweis hochzuladen',
      createCompanyBtn: 'Unternehmen erstellen',
      bankTitle: 'Bankdaten',
      bankSubtitlePP: 'Ihre IBAN und SWIFT/BIC werden für Auszahlungen verwendet, sobald Ihre Außenwerbungskampagnen aktiv sind.',
      bankSubtitleAdvertiser: 'Ihre IBAN und SWIFT/BIC werden für die Bearbeitung von Rückerstattungen verwendet, sofern zutreffend.',
      findTitle: 'Ihr Unternehmen finden',
      searchPlaceholder: 'Nach Unternehmensname suchen…',
      noCompanies: 'Kein Unternehmen gefunden. Nach Name suchen.',
      requestAccess: 'Zugang beantragen',
      requested: 'Beantragt',
      accessSentMsg:
        'Zugriffsanfrage gesendet! Ein Administrator des Unternehmens muss diese genehmigen. Sie werden benachrichtigt, wenn dies genehmigt wird.',
      pendingTitle: 'Zugriffsanfrage ausstehend',
      pendingDesc: 'Ihre Anfrage, {{name}} beizutreten, wird geprüft. Sie werden benachrichtigt, sobald sie genehmigt wird.',
      cancelRequest: 'Anfrage abbrechen',
      requestCancelled: 'Zugriffsanfrage abgebrochen.',
      connectingToEntity: 'Verbindung mit Ihrer Organisation…',
      accessApproved: 'Ihre Zugriffsanfrage wurde genehmigt! Sie sind jetzt Teil des Teams.',
      accessRejected: 'Ihre Zugriffsanfrage wurde abgelehnt. Bitte erstellen oder treten Sie einer anderen Geschäftseinheit bei.',
      orSetupYourOwn: 'Oder registrieren Sie Ihr Unternehmen oder treten Sie einem bestehenden bei.',
      invitationsTitle: 'Ausstehende Einladungen',
      invitationsSubtitle: 'Sie wurden eingeladen, einem Unternehmen beizutreten. Akzeptieren oder lehnen Sie unten ab.',
      invitedOn: 'Eingeladen am',
      acceptInvitation: 'Akzeptieren',
      declineInvitation: 'Ablehnen',
      invitationAccepted: 'Einladung angenommen! Verbindung mit Ihrer Organisation…',
      invitationDeclined: 'Einladung abgelehnt.',
    },
    details: {
      title: 'Unternehmensdetails',
      subtitle: 'Verwalten Sie Ihre Unternehmensregistrierung und Bankdaten.',
      registrationTitle: 'Registrierungsdetails',
      companyName: 'Unternehmensname',
      vatNumber: 'USt-IdNr.',
      companyEmail: 'Unternehmens-E-Mail',
      currency: 'Bevorzugte Währung',
      country: 'Land',
      portugueseRegion: 'Portugiesische Region',
      regionContinent: 'Kontinent',
      regionAzores: 'Azoren',
      regionMadeira: 'Madeira',
      replaceProof: 'Nachweisdokument ersetzen',
      uploadProof: 'Klicken, um ein neues Nachweisdokument hochzuladen',
      saveChanges: 'Änderungen speichern',
      addressSectionTitle: 'Adresse',
      addressLine: 'Adresse',
      addressLinePlaceholder: 'Hauptstraße 123',
      city: 'Stadt',
      postCode: 'Postleitzahl',
      state: 'Bundesstaat',
      stateHint: 'Erforderlich für USD-Auszahlungskonten',
      selectState: 'Bundesstaat auswählen',
      bankTitle: 'Bankdaten',
      bankSubtitle: 'Wird für den Empfang von Zahlungen von Werbetreibenden verwendet.',
      bankSubtitlePP: 'Ihre IBAN und SWIFT/BIC werden für Auszahlungen verwendet, sobald Kampagnen aktiv sind.',
      bankSubtitleAdvertiser: 'Ihre IBAN und SWIFT/BIC werden für Rückerstattungen verwendet, sofern zutreffend.',
      bankClickUnlock: 'Gesperrt - zum Bearbeiten klicken',
      iban: 'IBAN',
      swift: 'SWIFT / BIC',
      ibanHint: 'Internationale Bankkontonummer...',
      swiftHint: '8 oder 11 Zeichen: Bankcode (4) + Land (2) + Standort (2) + optionale Filiale (3)',
      accountNumber: 'Kontonummer',
      accountNumberHint: 'Ihre USD-Bankkontonummer (4–17 Ziffern)',
      saveBankDetails: 'Bankdaten speichern',
      verifiedLocked: 'Firmenname, USt-IdNr. und Land sind nach der Verifizierung gesperrt.',
      verifiedBadge: 'Verifiziert',
      pendingReviewTitle: 'Warte auf Genehmigung',
      pendingReviewDesc: 'Ihre Unternehmensregistrierung wird geprüft. Sobald unser Team sie genehmigt, erhalten Sie vollen Zugang zur Plattform - wir benachrichtigen Sie in Echtzeit.',
      verifiedTitle: 'Identität bestätigt',
      verifiedDesc: 'Die Identität Ihres Unternehmens wurde bestätigt. Keine weiteren Unterlagen erforderlich.',
      proofCardTitle: 'Verifizierungsdokument',
      proofCardDesc: 'Laden Sie Ihr Unternehmensregistrierungsdokument hoch, um die Verifizierung Ihres Kontos zu unterstützen. Unser Team wird es prüfen und sich bei Bedarf melden.',
      proofCardSubmit: 'Zur Prüfung einreichen',
      proofCardSuccess: 'Dokument erfolgreich eingereicht. Unser Team wird es prüfen und sich bei Bedarf melden.',
      proofCardValidatingTitle: 'Dokumente werden geprüft',
      proofCardValidatingDesc: 'Ihre Verifizierungsdokumente wurden erhalten und werden derzeit von unserem Team geprüft. Wir benachrichtigen Sie, sobald der Prozess abgeschlossen ist.',
      proofCardProcessingTitle: 'Datei wird verarbeitet',
      proofCardProcessingDesc: 'Wir haben Ihr Dokument erhalten und prüfen es automatisch. Das dauert nicht lange.',
      proofCardReplaceFile: 'Falsche Datei hochgeladen? Ersetzen',
    },
  },
  search: {
    instantBookingHint: 'Sofort bestätigt, ohne Freigabe durch den Anbieter',
    priceFilterLocked: 'Preisfilter sind verfügbar, sobald Sie angemeldet und mit einem Unternehmen verknüpft sind.',
    title: 'Werbeflächen suchen',
    subtitle: 'Werbeflächen auf der Karte finden',
    filters: 'Filter',
    minWidth: 'Mindestbreite (m)',
    maxWidth: 'Maximalbreite (m)',
    minHeight: 'Mindesthöhe (m)',
    maxHeight: 'Maximalhöhe (m)',
    minPrice: 'Mindestpreis (€/Tag)',
    maxPrice: 'Höchstpreis (€/Tag)',
    providerName: 'Anbietername',
    clearFilters: 'Filter zurücksetzen',
    noResults: 'Keine Werbeflächen in diesem Bereich gefunden',
    noResultsDesc: 'Versuchen Sie, den Kartenausschnitt zu erweitern, die Filter anzupassen oder die Kampagnenlaufzeit zu verlängern, um mehr Verfügbarkeiten zu erhalten.',
    addToCart: 'In den Warenkorb',
    inCart: 'Im Warenkorb',
    selectDates: 'Daten auswählen',
    from: 'Von',
    to: 'Bis',
    results: 'Ergebnisse',
    loading: 'Werbeflächen werden geladen…',
    resultsTab: 'Ergebnisse ({{count}})',
    mapTab: 'Karte',
    searching: 'Suche läuft…',
    found: '{{count}} Werbefläche gefunden',
    found_plural: '{{count}} Werbeflächen gefunden',
    moveMap: 'Karte verschieben, um Ergebnisse zu aktualisieren',
    noticePeriodHint: 'Einige Anbieter verlangen eine Mindestvorlaufzeit oder eine Mindestmietdauer, bevor eine Kampagne starten kann, was die Verfügbarkeit und die Suchergebnisse beeinflussen kann.',
    noOutdoorsFound: 'Keine Werbeflächen gefunden',
    noOutdoorsFoundAdjustDates: 'Bitte passen Sie Ihr Start- und Enddatum an, oder zoomen Sie heraus.',
    noOutdoorsFoundAdjustFilters: 'Zoomen Sie heraus oder passen Sie Ihre Filter an.',
    inCampaign: 'In der Kampagne',
    attributes: 'In der Nähe von',
    withDiscounts: 'Mengenrabatte verfügbar',
    illuminated: 'Nur beleuchtete',
    illuminatedHint: 'Werbefläche ist beleuchtet (z. B. nachts)',
    containsDiscounts: 'Mengenrabatte',
    containsDiscountsDesc: 'Diese Werbefläche bietet gestaffelte Preise - je mehr Tage Sie buchen, desto günstiger der Tagespreis.',
  },
  outdoor: {
    startAtMonthFirstDay: 'Beginn am 1. des Monats',
    startAtMonthFirstDayHint: 'Buchungen müssen am 1. Tag eines Monats beginnen. Mit „Nur volle Monate“ laufen sie in ganzen Kalendermonaten (vom 1. bis zum letzten Tag).',
    acceptingToastOn: '{{name}} nimmt jetzt neue Kampagnen an.',
    acceptingToastOff: '{{name}} ist pausiert - in der Suche ausgeblendet und für neue Buchungen geschlossen.',
    acceptingToastBulkOn: '{{count}} Standort(e) nehmen jetzt neue Kampagnen an.',
    acceptingToastBulkOff: '{{count}} Standort(e) pausiert - in der Suche ausgeblendet und für neue Buchungen geschlossen.',
    fullMonthRequired: 'Nur volle Monate',
    fullMonthRequiredHint: 'Werbetreibende buchen monatsweise: vom Starttag bis zum selben Tag des Folgemonats (bei Start am 1. bis zum letzten Tag des Monats), für beliebig viele aufeinanderfolgende Monate.',
    fullMonthTooltip: 'Monatsweise buchbar - vom Starttag bis zum selben Tag eines Folgemonats.',
    stepsTitle: 'Standort einrichten',
    stepNotSet: 'Noch nicht festgelegt',
    stepLocationSet: 'Position gesetzt',
    stepNoticeSummary: 'Vorlauf: {{count}} Tag(e)',
    stepPhotosSummary: 'Fotos: {{count}}',
    stepPhotosNone: 'Noch keine Fotos',
    stepBlockedSummary: 'Gesperrte Zeiträume: {{count}}',
    stepOptional: 'Optional',
    stepFeaturesSummary: 'Ausgewählt: {{count}}',
    fixHighlightedFields: 'Einige Angaben müssen korrigiert werden - wir haben den betroffenen Schritt geöffnet.',
    instantBooking: 'Sofortbuchung',
    instantBookingTooltip: 'Sofort gebucht - ohne auf die Bestätigung des Anbieters zu warten.',
    instantBookingHint: 'Werbetreibende buchen diesen Standort sofort, ohne auf Ihre Freigabe zu warten. Ausgeschaltet lassen, um jede Buchung zuerst zu prüfen.',
    kmAway: '{{distance}} km entfernt',
    productionCost: 'Produktionskosten',
    productionCostIncludes: 'inkl. Kosten für Druck, Montage usw.',
    priceHiddenTitle: 'Tageswerte für Geschäftskonten',
    priceHiddenMessage: 'Bitte melden Sie sich an und stellen Sie sicher, dass Sie mit einem Unternehmen (Flächenanbieter oder Werbetreibender) verknüpft sind, um den Tageswert des Standorts zu sehen.',
    manageTitle: 'Werbeflächen verwalten',
    addNew: 'Neue Werbefläche hinzufügen',
    noOutdoors: 'Noch keine Werbeflächen',
    noOutdoorsDesc: 'Fügen Sie Ihre erste Werbefläche hinzu, um Buchungen zu erhalten.',
    addFirst: 'Erste Werbefläche hinzufügen',
    editTitle: 'Werbefläche bearbeiten',
    createTitle: 'Neue Werbefläche hinzufügen',
    listSubtitle: 'Werbefläche bei Scapow einstellen.',
    editSubtitle: 'Details der Werbefläche aktualisieren.',
    location: 'Standort',
    latitude: 'Breitengrad',
    longitude: 'Längengrad',
    name: 'Name',
    namePlaceholder: 'z.B. Kurfürstendamm – Billboard A',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Premium-Werbefläche am Kurfürstendamm, stark frequentierte Zone…',
    dimensions: 'Abmessungen & Spezifikationen',
    width: 'Breite (m)',
    height: 'Höhe (m)',
    length: 'Länge (m)',
    aspectRatio: 'Seitenverhältnis des Werbemittels',
    aspectRatioHint: 'Automatisch aus Breite ÷ Höhe berechnet',
    bleed: 'Beschnitt (m)',
    bleedHint: 'Druckbereich über die endgültige Schnittlinie hinaus - gewährleistet saubere Kanten nach dem Zuschnitt.',
    illuminated: 'Beleuchtet',
    illuminatedHint: 'Diese Werbefläche ist beleuchtet und bleibt auch nachts sichtbar.',
    currency: 'Währung',
    currencyLockedHint: 'Wird durch die Währung Ihres Anbieterkontos festgelegt.',
    pricing: 'Preisgestaltung',
    excludeVat: 'zzgl. MwSt.',
    vatIncluded: 'inkl. MwSt.',
    pricePerDay: 'Preis pro Tag',
    volumeDiscounts: 'Mengenrabatte',
    addDiscount: 'Hinzufügen',
    daysArrow: 'Tage →',
    percentOff: '% Rabatt',
    photos: 'Standortfotos',
    photosHint: 'Fotos werden beim Hochladen oder Entfernen automatisch gespeichert.',
    uploadPhotos: 'Klicken, um Standortfotos hochzuladen',
    addMorePhotos: 'Weitere Fotos hinzufügen',
    currentPhotos: 'Aktuelle Fotos',
    uploadingPhotos: 'Fotos werden hochgeladen...',
    photosUploaded: 'Fotos erfolgreich hochgeladen',
    deletePhotoTitle: 'Foto löschen?',
    deletePhotoConfirm: 'Dieses Foto wird dauerhaft von diesem Outdoor entfernt.',
    filesSelected_one: '{{count}} Datei ausgewählt',
    filesSelected_other: '{{count}} Dateien ausgewählt',
    blockedTimes: 'Gesperrte Zeiten',
    blockedTimesDesc:
      'Sperren Sie Datumsangaben, an denen die Werbefläche nicht verfügbar ist (Wartung, externe Vorabreservierungen usw.).',
    blockedTimesOverlapNote: 'Zeiträume dürfen sich nicht überschneiden und nicht mit aktiven Kampagnenbuchungen kollidieren.',
    blockFrom: 'Sperren ab',
    blockUntil: 'Sperren bis',
    addBlockedTime: 'Gesperrte Zeit hinzufügen',
    noBlockedTimes: 'Keine gesperrten Zeiten',
    occupiedByCampaign: 'Von einer Kampagne gebucht',
    unsaved: 'Nicht gespeichert',
    unsavedChanges: '{{count}} nicht gespeicherte Änderung(en) - speichern Sie das Outdoor, um sie anzuwenden',
    selectBlockedDates: 'Bitte wählen Sie ein Start- und ein Enddatum aus.',
    legalDeclaration: 'Ich erkläre, dass ich rechtliche Rechte an dieser Werbefläche besitze, berechtigt bin, sie kommerziell anzubieten, und dass dies allen geltenden Gesetzen, Genehmigungen und Vorschriften entspricht.',
    legalDeclarationRequired: 'Sie müssen Ihre rechtlichen Rechte an dieser Werbefläche bestätigen, bevor Sie sie einstellen.',
    createOutdoor: 'Werbefläche erstellen',
    saveChanges: 'Änderungen speichern',
    deleteTitle: 'Werbefläche löschen',
    deleteConfirm: 'Sind Sie sicher, dass Sie diese Werbefläche löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    hidden: 'Versteckt',
    visible: 'Sichtbar',
    viewDetails: 'Details anzeigen',
    bookingRules: 'Buchungsregeln',
    bookingRulesDesc: 'Legen Sie die Vorlaufanforderungen fest, die Werbetreibende vor dem Kampagnenstartdatum erfüllen müssen.',
    minimumNoticeDays: 'Mindestvorlauf (Tage)',
    minimumNoticeDaysHint: 'Kampagnen müssen mindestens diese Anzahl von Tagen vor dem Startdatum vollständig bezahlt und das Kreativmaterial hochgeladen sein.',
    minimumDays: 'Mindestmietdauer (Tage)',
    minimumDaysHint: 'Die Mindestanzahl an Tagen, für die Werbetreibende diese Fläche mieten müssen.',
    acceptingCampaigns: 'Neue Kampagnen werden akzeptiert',
    acceptingCampaignsOn: 'Dieses Outdoor ist in der Suche sichtbar und kann zu Kampagnen hinzugefügt werden.',
    acceptingCampaignsOff: 'Dieses Outdoor ist in der Suche ausgeblendet und erhält keine neuen Buchungen.',
    acceptingBadge: 'Kampagnen werden akzeptiert',
    notAcceptingBadge: 'Keine Kampagnen',
    notAcceptingMsg: 'Dieses Outdoor akzeptiert derzeit keine neuen Kampagnen.',
    unavailableForDates: 'Dieses Outdoor ist für die ausgewählten Daten nicht verfügbar.',
    paused: 'Pausiert',
    accepting: 'Aktiv',
    availabilityToggleTooltip: 'Ob dieses Outdoor für Kampagnen verfügbar ist oder nicht. Aktueller Status: {{state}}',
    availabilityStateOn: 'Verfügbar',
    availabilityStateOff: 'Nicht verfügbar',
    toggleError: 'Aktualisierung der Kampagnensichtbarkeit fehlgeschlagen.',
    bulkAccept: 'Kampagnen für alle Outdoors auf dieser Seite aktivieren',
    bulkPause: 'Kampagnen für alle Outdoors auf dieser Seite pausieren',
    commissionNote: 'Werbetreibenden wird <bold>{{currency}} {{advertiserPrice}}/Tag</bold> angezeigt - Ihr {{currency}} {{basePrice}} zzgl. <bold>{{rate}}% Scapow-Provision</bold>.',
    advertiserPaysLabel: 'Werbetreibender zahlt',
    advertiserPaysDesc: 'Inkl. {{rate}}% Scapow-Aufschlag',
    youReceiveLabel: '{{name}} erhält',
    youReceiveDesc: 'Nach {{rate}}% Plattformgebühr (MwSt. auf die Provision kann anfallen)',
    searchByAddress: 'Nach Adresse suchen',
    dragPin: 'Ziehen Sie den Pin, um die genaue Position feinzujustieren.',
    myOutdoors: 'Meine Werbeflächen',
    myOutdoorsSubtitle: 'Verwalten Sie Ihr Werbeflächen-Inventar',
    viewCalendarTooltip: 'Sehen Sie sich die blockierten Termine für dieses Outdoor an',
    calendarModalTitle: 'Kalender - {{name}}',
    addOutdoor: 'Werbefläche hinzufügen',
    searchByName: 'Nach Name suchen…',
    deleteConfirmNamed: 'Sind Sie sicher, dass Sie "{{name}}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    specifications: 'Spezifikationen',
    creativeRatio: 'Seitenverhältnis des Werbemittels',
    coordinates: 'Koordinaten',
    price: 'Preis',
    plusVat: '+ MwSt.',
    unavailableDates: 'Nicht verfügbare Daten',
    duration: 'Dauer',
    addToCampaign: 'Zur Kampagne hinzufügen',
    goToCampaign: 'Zur Kampagne',
    signInToAdd: 'Melden Sie sich an/Registrieren Sie sich, um dieses Outdoor Ihrer Kampagne hinzuzufügen',
    bookingsCalendarTitle: 'Buchungskalender',
    bookingsCalendarSubtitle: 'Sehen Sie, wann Ihre Kampagnen starten, laufen und enden. Wählen Sie einen Tag, um die gebuchten Standorte zu sehen.',
    legend_starting: 'Kampagnenstart',
    legend_startingDesc: 'Eine Buchung geht live',
    legend_running: 'Kampagne läuft',
    legend_runningDesc: 'Ihr Standort ist on air',
    legend_finishing: 'Kampagnenende',
    legend_finishingDesc: 'Letzter Tag einer Buchung',
    legend_blocked: 'Gesperrte Termine',
    legend_blockedDesc: 'Standorte, die Sie nicht verfügbar gemacht haben',
    legend_none: 'Keine Buchungen',
    legend_noneDesc: 'Keiner Ihrer Standorte ist gebucht',
    legend_mixed: 'Geteilte Farben: An diesem Tag trifft mehr als eines zu',
    calendarToday: 'Heute',
    selectDayHint: 'Wählen Sie einen Tag, um seine Buchungen zu sehen. Erneut klicken zum Aufheben.',
    clearDateSelection: 'Datumsauswahl aufheben',
    dailyStatesError: 'Die Buchungen dieses Monats konnten nicht geladen werden. Bitte aktualisieren.',
    searchBookedByName: 'Gebuchte Standorte nach Namen suchen…',
    clearSearch: 'Suche löschen',
    bookedOutdoorsCount: 'Gebuchte Standorte: {{count}}',
    noBookingsOnDate: 'An diesem Tag sind keine Standorte gebucht',
    noBookedOutdoorsMatch: 'An diesem Tag passt kein gebuchter Standort zu „{{name}}“',
    noBookingsOnDateHint: 'Wählen Sie einen anderen Tag oder heben Sie das Datum auf, um alle Standorte zu sehen.',
    bookingPeriod: 'Buchungszeitraum',
    logIn: 'Anmelden',
    register: 'Registrieren',
    selectCampaignToAdd: 'Bitte wählen Sie eine Kampagne aus, um diesen Standort hinzuzufügen',
    changeCampaign: 'Ändern',
    alreadyInCampaign: 'Bereits in der Kampagne',
    billboardFallback: 'Außenwerbung',
    bookMoreThanDays: 'Buchen Sie mehr als {{count}} Tage',
    percentageOff: '{{percentage}}% Rabatt',
    comingSoon: 'Ihre Werbeflächen werden bald hier sein!',
    attributes: 'In der Nähe von',
    attributesHint: 'Helfen Sie Werbetreibenden, Sie schneller zu finden. Markieren Sie, was in der Nähe ist, um Ihre Werbefläche in den Suchergebnissen besser sichtbar zu machen.',
  },
  outdoorDetail: {
    productionCost: 'Produktionskosten',
    bookingTitle: 'Diese Werbefläche buchen',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    estimatedCost: 'Geschätzte Kosten',
    addToCart: 'In den Warenkorb',
    inCart: 'Bereits im Warenkorb',
    specs: 'Spezifikationen',
    dimensions: 'Abmessungen',
    aspectRatio: 'Erforderliches Seitenverhältnis',
    pricePerDay: 'Preis pro Tag',
    location: 'Standort',
    blockedTimes: 'Gesperrte Zeiträume',
    discounts: 'Mengenrabatte',
    noBlockedTimes: 'Keine gesperrten Zeiträume',
    noDiscounts: 'Keine Rabatte verfügbar',
    photos: 'Fotos',
    days: 'Tage',
    total: 'Gesamt',
    discount: 'Rabatt',
    campaignBookings: 'Kampagnenbuchungen',
    inCampaign: 'In Kampagne',
    minimumNoticeInDays: 'Mindestvorlaufzeit',
  },
  campaign: {
    methodFlowLabel: 'So bezahlen Sie',
    methodFirstPayment: '1. Zahlung',
    methodCard: 'Karte',
    methodThenMonthly: 'Danach monatlich',
    methodThenTrimonthly: 'Danach alle 3 Monate',
    methodDirectDebit: 'Lastschrift',
    searchByName: 'Kampagnen nach Namen suchen…',
    clearSearch: 'Suche löschen',
    resultsSummary: 'Ergebnisse: {{total}} · Seite {{page}} von {{pages}}',
    noSearchResults: 'Keine Kampagne passt zu „{{name}}“',
    noSearchResultsHint: 'Prüfen Sie die Schreibweise oder versuchen Sie einen anderen Namen.',
    eventFeedbackReceived: 'Ein Anbieter hat zu den Standorten Ihrer Kampagne geantwortet.',
    eventConfirmationUpdated: 'Die Bestätigung Ihrer Kampagne ist abgeschlossen - sehen Sie sich den neuen Status an.',
    eventViewCampaign: 'Kampagne ansehen',
    planTrimonthlyTitle: 'Alle 3 Monate zahlen',
    planTrimonthlyDesc: 'Jetzt Produktionskosten und die ersten 3 Monate zahlen. Jedes weitere Quartal wird an seinem ersten Tag per Lastschrift eingezogen.',
    visitCampaignPage: 'Zur Kampagnenseite',
    payStepNotice: 'Die Verfügbarkeit der Standorte wird beim Bezahlen erneut geprüft - bei Änderungen informieren wir Sie vor der Belastung.',
    removeOutdoor: 'Diesen Standort entfernen',
    noOutdoorsYetDesc: 'Finden Sie auf der Karte Standorte für Ihre Kampagne und wählen Sie Ihre Termine.',
    creativesNeedOutdoors: 'Fügen Sie zuerst Standorte hinzu - die benötigten Werbemittel hängen von deren Größe ab.',
    stepAnnounce: 'Schritt {{n}} von {{total}}: {{step}}',
    stepsDone: '{{done}} von {{total}} erledigt',
    stepDone: 'Erledigt',
    stepToDo: 'Offen',
    stepPrevious: 'Zurück: {{step}}',
    stepNext: 'Weiter: {{step}}',
    stepOutdoorsSummary: 'Standorte: {{count}}',
    stepCreativesSummary: '{{done}} von {{total}} bereit',
    stepTermsAccepted: 'Akzeptiert',
    stepTermsPending: 'Noch nicht akzeptiert',
    stepPendingHint_outdoors: 'Fügen Sie mindestens einen Standort hinzu, um fortzufahren.',
    stepPendingHint_creatives: 'Alle erforderlichen Werbemittel müssen hochgeladen und freigegeben sein.',
    stepPendingHint_terms: 'Akzeptieren Sie die Bedingungen, um die Zahlung freizuschalten.',
    goToPayment: 'Zur Zahlung',
    acceptTermsStepLabel: 'Ich habe die AGB für diese Kampagne gelesen und akzeptiere sie.',
    payStepTitle: 'Prüfen und bezahlen',
    payStepMissingTitle: 'Schließen Sie diese Schritte ab, um zu bezahlen:',
    payStepTotal: 'Kampagnensumme',
    scheduleTitle: 'Zahlungsplan',
    scheduleTotal: 'Gesamt {{amount}}',
    scheduleFullPayment: 'Gesamtzahlung',
    scheduleFirstPayment: 'Erste Zahlung · {{month}}',
    scheduleDueAtCheckout: 'Beim Checkout belastet',
    scheduleAuthorisedAtCheckout: 'Beim Checkout autorisiert, belastet nach Bestätigung der Anbieter',
    scheduleDueOn: 'Fällig am {{date}}',
    schedulePaidOn: 'Bezahlt am {{date}}',
    scheduleProcessing: 'In Bearbeitung - Lastschriften brauchen einige Tage',
    scheduleFailed: 'Zahlung fehlgeschlagen',
    scheduleCancelled: 'Storniert - wird nicht belastet',
    scheduleSplit: 'Produktion {{production}} · Kampagnentage {{ads}}',
    scheduleVatIncluded: 'Alle Beträge inkl. MwSt.',
    paymentsTitle: 'Zahlungen',
    paymentsPaidSoFar: 'Bisher bezahlt',
    paymentsRemaining: 'Noch offen: {{amount}}',
    paymentsFailedNotice: 'Eine Lastschrift ist fehlgeschlagen. Bitte prüfen Sie Ihr Bankkonto oder kontaktieren Sie uns, damit Ihre Kampagne nicht unterbrochen wird.',
    paymentPlanTitle: 'Wie möchten Sie bezahlen?',
    paymentPlanSubtitle: 'Vor dem Bezahlen wählen. Bis zur Zahlung änderbar.',
    planTotalTitle: 'Komplett bezahlen',
    planTotalDesc: 'Eine Zahlung für die gesamte Kampagne.',
    planMonthlyTitle: 'Monatlich bezahlen',
    planMonthlyDesc: 'Jetzt Produktionskosten und den ersten Monat zahlen. Jeder weitere Monat wird am 1. per Lastschrift eingezogen.',
    paymentPlanError: 'Der Zahlungsplan konnte nicht aktualisiert werden.',
    checkoutAllInstant: 'Alle Standorte sind sofort buchbar: Sie zahlen beim Checkout und Ihre Kampagne ist sofort bestätigt.',
    checkoutNeedsConfirmation: '{{count}} von {{total}} Standorten brauchen die Bestätigung des Anbieters. Beim Checkout wird Ihre Karte nur autorisiert - belastet wird erst nach der Bestätigung und nur für freigegebene Standorte.',
    mandateStepTitle: 'Schritt 1 von 2 · Lastschrift einrichten',
    mandateStepDesc: 'Danach leisten Sie Ihre erste Zahlung per Karte.',
    confirmingTitle: 'Warten auf die Bestätigung der Anbieter',
    confirmingDesc: 'Ihre Karte wurde autorisiert, nicht belastet. Belastet werden nur die Standorte, die ihre Anbieter freigeben.',
    awaitingDecisionTitle: 'Einige Standorte sind nicht verfügbar',
    awaitingDecisionDesc: 'Fahren Sie mit den freigegebenen Standorten fort oder stornieren Sie die Kampagne und geben Sie die Zahlung frei.',
    providersAnswerBy: 'Anbieter antworten bis {{date}}',
    decideBy: 'Entscheiden Sie bis {{date}} - sonst wird die Kampagne storniert und nichts belastet.',
    feedbackCount_approved: 'Freigegeben: {{count}}',
    feedbackCount_confirming: 'Antwort ausstehend: {{count}}',
    feedbackCount_unavailable: 'Nicht verfügbar: {{count}}',
    feedbackCount_expired: 'Nicht rechtzeitig beantwortet: {{count}}',
    proceedWithApproved: 'Mit freigegebenen Standorten fortfahren',
    proceedNoneApproved: 'Noch kein Standort wurde freigegeben.',
    removeConfirmingHint: 'Standorte mit ausstehender Antwort können Sie noch entfernen.',
    proceedModalTitle: 'Mit freigegebenen Standorten fortfahren?',
    proceedOutdoorsLabel: 'Gebuchte Standorte',
    proceedOutdoorsValue: '{{approved}} von {{total}}',
    proceedChargedLabel: 'Belastet werden',
    proceedTotalMonthlyLabel: 'Kampagnensumme',
    proceedModalNote: 'Dieser Betrag wird jetzt Ihrer Karte belastet.',
    proceedModalMonthlyNote: 'Ihre erste Zahlung wird jetzt eingezogen, der Rest in Raten per Lastschrift.',
    proceedModalDropped: 'Die übrigen Standorte ({{count}}) werden aus dieser Kampagne entfernt.',
    proceedSuccess: 'Ihre Kampagne ist bestätigt.',
    cancelDecisionTitle: 'Diese Kampagne stornieren?',
    cancelDecisionDesc: 'Die autorisierte Zahlung wird freigegeben und nichts belastet. Alle Standorte werden für andere Werbetreibende frei.',
    unavailableTitle: 'Keiner der Standorte war verfügbar',
    unavailableDesc: 'Die Anbieter konnten diese Termine nicht bestätigen, daher wurde nichts belastet. Versuchen Sie andere Termine oder Standorte.',
    feedback_CONFIRMING: 'Wartet auf Anbieter',
    feedback_APPROVED: 'Freigegeben',
    feedback_UNAVAILABLE: 'Nicht verfügbar',
    feedback_EXPIRED: 'Keine Antwort',
    creativeThumbnailAlt: 'Werbemittel der Kampagne {{name}}',
    title: 'Kampagnen',
    newCampaign: 'Neue Kampagne',
    newCampaignTooltip: 'Klicken, um eine neue Kampagne zu erstellen',
    mustRegisterAsAdvertiser: 'Sie müssen sich als Werbetreibender registrieren, um Kampagnen erstellen zu können',
    noCampaigns: 'Noch keine Kampagnen',
    noCampaignsDesc: 'Erstellen Sie Ihre erste Kampagne, um mit der Außenwerbung zu beginnen.',
    browseSpaces: 'Werbeflächen erkunden',
    status: 'Status',
    from: 'Von',
    to: 'Bis',
    filter: 'Filtern',
    clearFilter: 'Filter löschen',
    outdoorSlots: 'Werbeflächen',
    outdoorsColHeader: 'Flächen',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    paginationRange: 'Kampagnen {{from}}-{{to}} von {{total}}',
    creatives: 'Werbemittel',
    payment: 'Zahlung',
    deleteTitle: 'Kampagne löschen',
    deleteConfirm: 'Sind Sie sicher, dass Sie diese Kampagne löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    uploadCreative: 'Werbemittel hochladen',
    removeCreative: 'Entfernen',
    deletingCreative: 'Kreativ wird gelöscht…',
    creativeRatioMismatch: 'Das Bildformat entspricht nicht dem erforderlichen {{ratio}}-Format. Bitte laden Sie ein Bild mit den richtigen Proportionen oder ein PDF hoch.',
    getPaymentDetails: 'Zahlungsdetails abrufen',
    requiredRatios: 'Erforderliche Werbemittel-Seitenverhältnisse',
    iban: 'IBAN',
    reference: 'Zahlungsreferenz',
    viewCampaign: 'Ansehen',
    loading: 'Kampagnen werden geladen…',
    noSlots: 'Keine Werbeflächen-Slots in dieser Kampagne.',
    noCreatives: 'Noch keine Werbemittel hochgeladen.',
    subtitle: 'Verwalten Sie Ihre Außenwerbekampagnen',
    noFound: 'Keine Kampagnen gefunden',
    noFoundDesc: 'Beginnen Sie damit, Werbeflächen in Ihren Warenkorb zu legen, um Ihre erste Kampagne zu erstellen.',
    browseOutdoors: 'Werbeflächen erkunden',
    outdoorsCount: '{{count}} Werbefläche',
    outdoorsCount_plural: '{{count}} Werbeflächen',
    creativesCount: '{{count}} Werbemittel',
    paymentLabel: 'Zahlung: {{status}}',
    backToCampaigns: 'Zurück zu Kampagnen',
    checklistTitle: 'Kampagnen-Checkliste',
    checklistOutdoors: 'Werbeflächen für Ihre Kampagne auswählen',
    checklistCreatives: 'Werbemittel hinzufügen',
    checklistTerms: 'AGB akzeptieren',
    checklistPay: 'Kampagne bezahlen',
    acceptTermsPrefix: 'Ich akzeptiere die',
    acceptTermsLink: 'AGB',
    acceptTermsRequiredHint: 'Sie müssen die AGB akzeptieren, bevor Sie diese Kampagne bezahlen können.',
    advertiserTermsModalTitle: 'AGB für Werbetreibende und Kampagnen',
    advertiserTermsModalHint: 'Dies sind die Abschnitte unserer AGB, die speziell für Werbetreibende und Kampagnen gelten.',
    viewFullTerms: 'Vollständige AGB ansehen',
    outdoorsHeader: 'Werbeflächen ({{count}})',
    noOutdoorsYet: 'Noch keine Werbeflächen hinzugefügt.',
    requiredAspectRatios: 'Erforderliche Werbemittel-Seitenverhältnisse',
    recResolution: 'empfohlen: {{w}}×{{h}} cm @ {{dpi}} dpi (1:{{scale}})',
    recInclBleed: 'inkl. Beschnitt',
    dimensionsCalculatorBleedNote: 'Dieses Werbemedium hat {{bleed}} cm Beschnitt an jeder Kante, daher umfassen die Maße die gesamte Druckfläche von {{w}} × {{h}} m (sichtbare Fläche: {{trimW}} × {{trimH}} m).',
    orientationLandscape: 'Querformat',
    orientationPortrait: 'Hochformat',
    dimensionsCalculatorTooltip: 'Mögliche Werbemittelgrößen berechnen',
    dimensionsCalculatorTitle: 'Größenrechner für Werbemittel mit Seitenverhältnis {{ratio}}',
    dimensionsCalculatorHint: 'Ändern Sie Breite oder Höhe (in Zentimetern) - die andere Seite wird automatisch angepasst, um dieses Seitenverhältnis beizubehalten. Wir arbeiten immer mit 300 dpi und bevorzugen einen Maßstab von 1:10 der tatsächlichen Größe des Werbemediums.',
    dimensionsCalculatorWidthLabel: 'Breite (cm)',
    dimensionsCalculatorHeightLabel: 'Höhe (cm)',
    dimensionsCalculatorDpiLabel: 'Druckauflösung',
    dimensionsCalculatorScaleHint: 'Maßstab: 1:{{scale}} - wir empfehlen 1:10 oder ein größeres Design (kleinere Maßstabszahl).',
    dimensionsCalculatorExportHint: 'Exportieren Sie Ihre Datei mit {{w}} × {{h}} px.',
    dimensionsCalculatorMinQualityWidth: 'Zu klein für gute Druckqualität - mindestens {{min}} cm erforderlich für ein Design im Maßstab 1:{{scale}}.',
    dimensionsCalculatorMinQualityHeight: 'Zu klein für gute Druckqualität - mindestens {{min}} cm erforderlich für ein Design im Maßstab 1:{{scale}}.',
    processingImage: 'Bild wird verarbeitet...',
    noCreativesYet: 'Noch keine Werbemittel hochgeladen',
    creativesNote: 'Dies sind die Bilder, die während Ihrer Kampagne auf den Außenwerbeflächen zu sehen sein werden.',
    clickToUpload: 'Klicken, um hochzuladen',
    creativeValid: 'Genehmigt',
    creativeUnderReview: 'In Prüfung',
    creativeInvalid: 'Ungültig',
    deleteCreativeTitle: 'Kreativ löschen?',
    deleteCreativeBody: 'Dieses Kreativ wurde genehmigt oder wird geprüft. Durch das Löschen wird es aus der Kampagne entfernt und ein erneuter Upload ist erforderlich.',
    campaignInfo: 'Kampagneninfo',
    details: 'Details',
    requestPayment: 'Zahlung anfordern',
    paymentDetails: 'Zahlungsdetails',
    currency: 'Währung',
    bankTransferDetails: 'Banküberweisung Details',
    amount: 'Betrag',
    importantRef: '⚠️ Wichtig - Zahlungsreferenz',
    refNote: 'Sie müssen diese Referenz in der Beschreibung Ihrer Überweisung angeben, damit sie automatisch zugeordnet werden kann.',
    deleteCampaign: 'Kampagne löschen',
    deleteCampaignDesc: 'Dies wird diese Kampagne und alle damit verbundenen Daten dauerhaft löschen. Diese Aktion kann nicht rückgängig gemacht werden.',
    addOutdoor: 'Werbefläche hinzufügen',
    outdoorAdded: 'Werbefläche zur Kampagne hinzugefügt',
    selectOutdoor: 'Werbefläche auswählen',
    outdoorDateConflict: 'Diese Werbefläche ist in dieser Kampagne bereits für überlappende Zeiträume gebucht. Bitte wählen Sie andere Daten.',
    alreadyInCampaign: 'In Kampagne',
    name: 'Name',
    outdoorSubtotal: 'Zwischensumme',
    bankTransferNoticeTitle: 'Kampagnenzahlung erforderlich',
    bankTransferNotice: 'Ihre Kampagne wird erst aktiviert und alle Werbeflächen verbindlich gebucht, sobald die vollständige Zahlungsbestätigung vorliegt. Klicken Sie auf "Validieren & Bezahlen", um fortzufahren. Bitte beachten Sie: Die Verfügbarkeit der Werbeflächen wird zum Zeitpunkt der Zahlung erneut geprüft - Flächen, die beim Hinzufügen zur Kampagne verfügbar waren, können zwischenzeitlich vergeben worden sein.',
    requestPaymentDisabledHint: 'Alle {{count}} erforderlichen Creatives müssen hochgeladen und validiert sein (Status: Gültig), bevor eine Zahlung angefordert werden kann.',
    outdoorRemoved: 'Werbefläche aus der Kampagne entfernt.',
    removeOutdoorConfirm: 'Sind Sie sicher, dass Sie diese Werbefläche aus der Kampagne entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    qualityFail: 'Auflösung zu niedrig - Datei nicht hochgeladen',
    qualityWarn: 'Seitenverhältnis stimmt nicht - Bild könnte beschnitten oder mit Rand gedruckt werden',
    qualityAspectMismatch: 'Seitenverhältnis {{actual}} vs {{expected}} (Außenwerbung)',
    qualityUploadAnyway: 'Trotzdem hochladen',
    qualityConfirmHint: 'Das Bild könnte beschnitten oder mit Rand gedruckt werden, um dieses Format anzupassen.',
    qualityDetailFail: 'Diese Datei ist nur scharf genug für {{achievedScale}} auf einem Werbemedium von {{outdoorW}} × {{outdoorH}} m.',
    qualityTargetFail: 'Gestalten Sie Ihr Werbemittel mit {{w}} × {{h}} cm (Maßstab 1:{{scale}}, {{dpi}} dpi) für dieses Format.',
    recResolutionPx: 'empfohlen: {{w}}×{{h}}px @ {{dpi}} dpi',
    dimensionsCalculatorHintPx: 'Ändern Sie Breite oder Höhe - die andere Seite wird automatisch angepasst, um dieses Seitenverhältnis beizubehalten. Die effektive DPI wird ebenfalls aktualisiert, damit Sie alternative Abmessungen mit guter Druckqualität finden können.',
    dimensionsCalculatorWidthLabelPx: 'Breite (px)',
    dimensionsCalculatorHeightLabelPx: 'Höhe (px)',
    dimensionsCalculatorDpiLabelPx: 'Effektive DPI',
    dimensionsCalculatorMinDpiHintPx: 'Für dieses Werbemedium sind mindestens {{dpi}} dpi erforderlich.',
    dimensionsCalculatorMinQualityWidthPx: 'Mindestqualität der Breite noch nicht erreicht (mind. {{min}}px, empfohlen: {{rec}}px).',
    dimensionsCalculatorMinQualityHeightPx: 'Mindestqualität der Höhe noch nicht erreicht (mind. {{min}}px, empfohlen: {{rec}}px).',
    qualityWarnLowRes: 'Niedrige Auflösung - Bild könnte schlecht drucken',
    qualityConfirmHintLowRes: 'Das Bild kann mit sichtbarem Qualitätsverlust gedruckt werden.',
    qualityDetailWarnPx: '{{pixelW}} × {{pixelH}} px ergeben {{dpi}} DPI in voller Größe.',
    qualityDetailFailPx: '{{pixelW}} × {{pixelH}} px ergeben {{dpi}} DPI bei {{outdoorW}} × {{outdoorH}} m, unter dem Minimum von {{minDpi}} DPI.',
    qualityTargetWarnPx: 'Wir empfehlen mindestens {{recDpi}} DPI für dieses Format: {{recW}} × {{recH}} px oder {{recScaleLabel}}.',
    qualityTargetFailPx: 'Sie benötigen mindestens {{minW}} × {{minH}} px - bei 1:{{scale}} ist das eine {{canvasW}} × {{canvasH}} m Zeichenfläche bei {{designDpi}} DPI.',
    creativeUnitLabel: 'Größeneinheiten',
    creativeUnitCm: 'Zentimeter',
    creativeUnitPx: 'Pixel',
    creativeUnitHint: 'Wählen Sie, wie empfohlene Werbemittelgrößen angezeigt und geprüft werden. Zentimeter: Gestaltung im Maßstab 1:10 des Werbemediums, immer mit 300 dpi. Pixel: Mindestauflösung abhängig von der Größe des Werbemediums.',
    previewBadge: 'Vorschau',
    previewOnlyHint: 'Nur Vorschau - laden Sie das Original für den Druck herunter',
    downloadPrintFile: 'Druckdatei herunterladen',
    downloadPrintFileHint: 'Original in voller Auflösung',
    printFileExplainer: 'Das Bild oben ist eine kompakte Vorschau. Laden Sie die Originaldatei in voller Auflösung herunter, um sie in den Druck zu geben.',
    previewFailed: 'Für diese Datei konnte in Ihrem Browser keine Vorschau erstellt werden. Bitte exportieren Sie sie als JPG oder PNG und versuchen Sie es erneut.',
    creativeFileRequirements: 'Akzeptierte Dateien: TIF, TIFF, JPG, JPEG, PNG oder PDF. Für den Druck ist der CMYK-Farbmodus erforderlich. Bilder in anderen Farbmodi werden in CMYK konvertiert, mit einer Vorschau, die Sie vor dem Hochladen freigeben. PDF-Dateien müssen bereits in CMYK vorliegen.',
    creativeFormatNotAllowed: '„{{name}}“ ist kein akzeptierter Dateityp. Bitte laden Sie eine TIF-, TIFF-, JPG-, JPEG-, PNG- oder PDF-Datei hoch.',
    creativeNotCmykPdf: '„{{name}}“ enthält RGB-Farben (im Motiv oder in einem eingebetteten Bild). Druckdateien müssen vollständig CMYK sein - exportieren Sie sie erneut mit einem CMYK-Farbprofil (z. B. PDF/X-1a) und laden Sie sie hoch.',
    creativeUnreadable: '„{{name}}“ konnte nicht gelesen werden. Die Datei ist möglicherweise beschädigt oder ungewöhnlich gespeichert - bitte exportieren Sie sie erneut und versuchen Sie es noch einmal.',
    cmykNoticeTitle: '„{{name}}“ liegt nicht im CMYK-Farbmodus vor',
    cmykNoticeBody: 'Für den Druck ist CMYK erforderlich. Wir können die Datei mit dem Standardprofil für den Außenwerbedruck für Sie konvertieren - Sie prüfen eine Vorher-Nachher-Vorschau, bevor etwas hochgeladen wird.',
    cmykConvert: 'In CMYK konvertieren',
    cmykModalTitle: 'Für den Druck in CMYK konvertieren',
    cmykConverting: 'Konvertierung in CMYK ({{profile}})…',
    cmykBefore: 'Original',
    cmykAfter: 'Druckvorschau (CMYK)',
    cmykShiftWarning: 'Einige leuchtende Farben werden im Druck deutlich anders aussehen (etwa {{percent}} % des Bildes). Wenn exakte Farben wichtig sind, passen Sie das Motiv vor dem Hochladen in Ihrer Gestaltungssoftware an.',
    cmykProfileNote: 'Konvertiert mit dem Profil {{profile}}, dem Standard für den Außenwerbedruck. Bildschirme können CMYK nicht exakt darstellen - die Vorschau simuliert das Druckergebnis.',
    cmykAccept: 'Konvertierte CMYK-Version übernehmen',
    cmykErrorUnavailable: 'Die CMYK-Konvertierung ist vorübergehend nicht verfügbar. Bitte konvertieren Sie die Datei in Ihrer Gestaltungssoftware in CMYK und laden Sie sie erneut hoch.',
    cmykErrorTooLarge: 'Dieses Bild ist zu groß, um im Browser konvertiert zu werden. Bitte konvertieren Sie es in Ihrer Gestaltungssoftware in CMYK und laden Sie es erneut hoch.',
    cmykErrorFailed: 'Diese Datei konnte nicht konvertiert werden. Bitte konvertieren Sie sie in Ihrer Gestaltungssoftware in CMYK und laden Sie sie erneut hoch.',
    pay: 'Validieren & Bezahlen',
    commission: 'Plattformprovision ({{rate}}%)',
    vatLabel: 'MwSt.',
    vatWithRate: 'MwSt. ({{rate}}%)',
    vatDetailsTitle: 'MwSt.-Details',
    vatDetailsBody: 'Die MwSt. wird gemäß der geltenden steuerlichen Behandlung der jeweiligen Kampagnenbestandteile berechnet. Manche Beträge können MwSt. enthalten, einem anderen MwSt.-Satz unterliegen oder außerhalb der anwendbaren MwSt.-Bemessungsgrundlage liegen.',
    totalWithoutVat: 'Gesamt (ohne MwSt.)',
    grandTotal: 'Gesamtbetrag',
    dailyRateRoundingNote: 'Tagespreise werden auf den nächsten Cent gerundet.',
    platformFeeNote: '* Die Tagespreise für Werbeflächen beinhalten bereits eine Plattformprovision von 5%.',
    confirmPayment: 'Zahlung bestätigen',
    paymentSuccess: 'Zahlung erfolgreich! Ihre Kampagne wird in Kürze aktiviert.',
    checkingPayment: 'Zahlung wird überprüft…',
    paymentConfirmed: 'Zahlung Bestätigt!',
    paymentConfirmedDesc: 'Ihre Zahlung wurde bestätigt. Ihre Kampagne wird in Kürze aktiviert.',
    paymentPending: 'Zahlung Nicht Bestätigt',
    paymentPendingDesc: 'Ihre Zahlung konnte derzeit nicht bestätigt werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.',
    backToCampaign: 'Zurück zur Kampagne',
    expandPricing: 'Preisdetails anzeigen',
    collapsePricing: 'Preisdetails ausblenden',
    availabilityUpdated: 'Ein oder mehrere Standorte wurden aus Ihrer Kampagne entfernt - sie wurden von einer anderen Kampagne für überlappende Termine gebucht oder die Mindestvorlaufzeit war bereits abgelaufen. Bitte überprüfen Sie Ihre aktualisierte Auswahl unten.',
    availabilityDialogTitle: 'Verfügbarkeit bestätigen & zur Zahlung',
    availabilityDialogBody: 'Vor dem Fortfahren prüfen wir, ob alle ausgewählten Werbeflächen noch verfügbar sind. Einige könnten zwischenzeitlich von anderen Kampagnen reserviert worden sein. Bitte geben Sie an, wie Konflikte behandelt werden sollen.',
    availabilityRemoveYes: 'Ja - nicht verfügbare Flächen automatisch entfernen',
    availabilityRemoveYesDesc: 'Nicht mehr verfügbare Flächen werden aus dieser Kampagne entfernt. Sie können die aktualisierte Auswahl vor der Zahlung prüfen.',
    availabilityRemoveNo: 'Nein - Konflikte markieren und selbst prüfen',
    availabilityRemoveNoDesc: 'Konfliktbehaftete Flächen werden hervorgehoben, damit Sie die Daten anpassen oder sie manuell entfernen können.',
    availabilityDialogConfirm: 'Weiter zur Zahlung',
    outdoorFlaggedTitle: 'Daten nicht mehr verfügbar',
    outdoorFlaggedDesc: 'Diese Werbefläche wurde von einer anderen Kampagne für überlappende Termine reserviert. Bitte ändern Sie die Daten oder entfernen Sie sie, um fortzufahren.',
    outdatedOutdoorsTitle: 'Kampagne kann nicht fortgesetzt werden - veraltete Placements erkannt',
    outdatedOutdoorsDesc: 'Mindestens eine Kampagnenfläche hat ein bereits vergangenes Startdatum. Die Zahlung wurde nicht verarbeitet. Bitte überprüfen Sie die markierten Placements und aktualisieren Sie die Startdaten.',
    outdoorOutdatedTitle: 'Startdatum liegt in der Vergangenheit',
    outdoorOutdatedDesc: 'Das geplante Startdatum für dieses Placement ist bereits vergangen. Bitte aktualisieren Sie es auf ein zukünftiges Datum, um fortzufahren.',
    pastStartDatesToast: 'Kampagnenzeiträume dürfen nicht in der Vergangenheit liegen.',
    cancelCampaign: 'Kampagne abbrechen',
    cancelCampaignConfirm: 'Diese Aktion bricht Ihre Kampagne dauerhaft ab. Sind Sie sicher?',
    cancelCampaignYes: 'Ja, abbrechen',
    cancelCampaignAbort: 'Kampagne behalten',
    cancelledSuccess: 'Die Kampagne wurde abgebrochen.',
    cancellationPolicyPending: 'Kostenlose Stornierung - es fallen keine Gebühren an, solange sich Ihre Kampagne im Status „Ausstehend" befindet.',
    cancellationPolicyReady: 'Kostenlose Stornierung, wenn alle Outdoors mit mehr Vorlaufzeit storniert werden, als die Mindest-Vorankündigungsfrist des jeweiligen Flächenanbieters vorsieht. Fällt ein oder mehrere Outdoors in die Mindest-Vorankündigungsfrist, wird eine Stornierungsgebühr erhoben (zzgl. MwSt. für portugiesische Unternehmen). Produktionskosten (Druck, Montage usw.) sind für Outdoors innerhalb der Mindest-Vorankündigungsfrist nicht erstattungsfähig.',
    cancellationPolicyRunning: 'Bitte beachten: Die Stornierung einer bereits laufenden Kampagne führt zum vollständigen Verlust von 100 % des Kampagnenwerts. Eine Rückerstattung wird nicht gewährt.',
    ppInvoices: 'Rechnungen der Placement-Anbieter',
    outdoorAdj0: 'atemberaubende',
    outdoorAdj1: 'großartige',
    outdoorAdj2: 'prächtige',
    outdoorAdj3: 'fabelhafte',
    outdoorAdj4: 'herausragende',
    outdoorsCollapsedSummary: 'Hier haben wir {{count}} {{adj}} Outdoors!',
    messages: 'Nachrichten',
    noMessages: 'Noch kein Werbeflächen-Anbieter hat Nachrichten zu dieser Kampagne gesendet. Sobald dies der Fall ist, erscheinen die Gespräche hier.',
    noMessagesYet: 'In dieser Unterhaltung gibt es noch keine Nachrichten.',
    typeMessage: 'Nachricht eingeben…',
    instructions: 'Anweisungen für Werbeflächen-Anbieter',
    instructionsPlaceholder: 'z.B. Bitte nur von 8 bis 22 Uhr anzeigen.',
    instructionsEmpty: 'Noch keine Anweisungen hinzugefügt. Klicken Sie auf Bearbeiten, um Hinweise hinzuzufügen.',
    instructionsSaved: 'Anweisungen gespeichert.',
    proofOfDisplay: 'Nachweisfotos',
    proofPending: 'Nachweis kommt bald',
    proofPendingDesc: 'Ihr Flächenanbieter wird den Nachweis in Kürze hochladen.',
    proofAlt: 'Nachweis – {{name}}',
    additionalFiles: 'Zusätzliche Dateien',
    additionalFilesSubtitle: 'Begleitmaterial für diese Kampagne – nicht zwingend erforderlich.',
    additionalFilesSubtitlePP: 'Vom Werbetreibenden bereitgestelltes Begleitmaterial.',
    noAdditionalFiles: 'Noch keine zusätzlichen Dateien hochgeladen.',
    uploadFile: 'Datei hochladen',
    fileUploaded: 'Datei erfolgreich hochgeladen.',
    fileDeleted: 'Datei entfernt.',
    deleteFile: 'Datei löschen',
    addOutdoors: 'Werbeflächen hinzufügen',
    creativesLockedTitle: 'Noch keine Werbeflächen hinzugefügt',
    creativesLockedDesc: 'Creatives müssen der erforderlichen Auflösung jeder Werbefläche entsprechen. Fügen Sie mindestens eine Werbefläche hinzu, um Uploads zu ermöglichen.',
    editDates: 'Daten bearbeiten',
    updateDates: 'Daten aktualisieren',
    datesUpdated: 'Daten erfolgreich aktualisiert',
  },
  dashboard: {
    title: 'Dashboard',
    earnings: 'Einnahmen',
    spendings: 'Ausgaben',
    last30: 'Letzte 30 Tage',
    last90: 'Letzte 90 Tage',
    thisYear: 'Dieses Jahr',
    accessRequests: 'Zugriffsanfragen',
    noRequests: 'Keine ausstehenden Anfragen',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    teamInvite: 'Teammitglied einladen',
    inviteEmail: 'E-Mail-Adresse',
    sendInvite: 'Einladung senden',
    totalEarned: 'Gesamteinnahmen',
    totalSpent: 'Gesamtausgaben',
    activeOutdoors: 'Aktive Werbeflächen',
    activeCampaigns: 'Aktive Kampagnen',
    overview: 'Übersicht',
    howPaidTitle: 'Wie Sie bezahlt werden',
    howPaidDesc: 'Sobald eine Kampagne live ist, laden Sie Fotobeweise für jede Werbefläche hoch. Wenn alle Nachweise verifiziert wurden, wird Ihre Zahlung automatisch freigegeben. Ihre Auszahlung errechnet sich aus Ihrem täglichen Listenpreis multipliziert mit der Anzahl der aktiven Kampagnentage, abzüglich einer Plattform-Servicegebühr von 5 % pro Buchung.',
    ppOverview: 'Übersicht Flächenanbieter',
    advertiserOverview: 'Übersicht Werbetreibender',
    findOutdoors: 'Werbeflächen finden',
    addOutdoor: 'Werbefläche hinzufügen',
    viewCampaigns: 'Kampagnen anzeigen',
    manageOutdoors: 'Werbeflächen verwalten',
    companyDetails: 'Unternehmensdetails',
    userDetails: 'Kontodetails',
    pendingRequests: 'Ausstehende Zugriffsanfragen ({{count}})',
    inviteDesc: 'Sie erhalten eine E-Mail mit einem Link, um Ihrem Unternehmen bei Scapow beizutreten.',
    invitePlaceholder: 'kollege@unternehmen.com',
    invoicesTitle: 'Rechnungen',
    downloadInvoice: 'Herunterladen',
    invoiceIssued: 'Ausgestellt',
    invoicePaid: 'Bezahlt',
    invoiceUnknownCampaign: 'Unbekannte Kampagne',
    invoicesSubtitle: 'Ihre Zahlungshistorie und herunterladbare Rechnungsdokumente.',
    invoicesEmpty: 'Wir freuen uns darauf, diesen Bereich für Sie zu füllen!',
  },
  invoices: {
    title: 'Rechnungen',
    subtitleAdvertiser: 'Scapow- und Anbieterrechnungen für alle Ihre Kampagnen.',
    subtitlePP: 'Ihr Zahlungsverlauf und herunterladbare Rechnungen.',
    issued: 'Ausgestellt',
    download: 'Herunterladen',
    empty: 'Noch keine Rechnungen. Sie erscheinen hier, sobald Ihre Kampagnen bearbeitet wurden.',
    unknownCampaign: 'Unbekannte Kampagne',
    ppInvoices: 'Anbieterrechnungen ({{count}})',
    unknownProvider: 'Unbekannter Anbieter',
    notAvailable: 'Nicht verfügbar',
    typeInvoice: 'Rechnung',
    typeCreditNote: 'Gutschrift',
  },
  payments: {
    title: 'Zahlungen',
    subtitle: 'Ihr Zahlungsverlauf für Kampagnen auf Ihren Werbeflächen.',
    empty: 'Noch keine Zahlungen. Sie erscheinen hier, sobald Ihre Kampagnen ausgezahlt wurden.',
    unknownCampaign: 'Unbekannte Kampagne',
    columnId: 'Zahlungs-ID',
    columnCampaign: 'Kampagne',
    columnValue: 'Betrag',
    columnPaidAt: 'Bezahlt am',
    columnStatus: 'Status',
    statusPaid: 'Bezahlt',
    statusTransferRequested: 'Überweisung angefordert',
  },
  userDetails: {
    receiveEmails: 'E-Mails erhalten',
    receiveEmailsOnDesc: 'Plattform-E-Mails werden an {{email}} gesendet.',
    receiveEmailsOffDesc: 'Sie erhalten keine Plattform-E-Mails. Schalten Sie dies ein, um sie wieder zu erhalten.',
    emailsTurnedOn: 'Sie erhalten Plattform-E-Mails.',
    emailsTurnedOff: 'Sie erhalten keine Plattform-E-Mails mehr.',
    emailsUpdateError: 'Ihre E-Mail-Einstellung konnte nicht aktualisiert werden.',
    title: 'Kontodetails',
    subtitle: 'Verwalten Sie Ihre persönlichen Kontoinformationen.',
    name: 'Name',
    editName: 'Zum Bearbeiten klicken',
    email: 'E-Mail',
    memberSince: 'Mitglied seit (UTC)',
    accountStatus: 'Kontostatus',
    statusVerified: 'Verifiziert',
    statusPending: 'Verifizierung ausstehend',
    nameUpdated: 'Name erfolgreich aktualisiert.',
    nameRequired: 'Bitte geben Sie einen gültigen Namen ein (mindestens 2 Zeichen).',
    password: 'Passwort',
    changePassword: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    passwordUpdated: 'Passwort erfolgreich aktualisiert.',
    passwordFieldsRequired: 'Bitte füllen Sie alle Passwortfelder aus.',
    passwordTooShort: 'Das neue Passwort muss mindestens 8 Zeichen lang sein.',
    passwordSameAsCurrent: 'Das neue Passwort muss sich von Ihrem aktuellen Passwort unterscheiden.',
    passwordMismatch: 'Das neue Passwort und die Bestätigung stimmen nicht überein.',
  },
  admin: {
    tabUnpaidInstallments: 'Unbezahlte Raten',
    unpaidInstallmentsIntro: 'Raten, die 6 Tage nach Fälligkeit noch unbezahlt sind, älteste zuerst.',
    noUnpaidInstallments: 'Keine unbezahlten Raten.',
    installmentOf: 'Rate {{number}} von {{total}}',
    installmentNumber: 'Rate {{number}}',
    installmentDue: 'Fällig am {{date}}',
    installmentOverdueDays_one: '{{count}} Tag überfällig',
    installmentOverdueDays_other: '{{count}} Tage überfällig',
    proofOfCompany: 'Unternehmensnachweis',
    openProofOfCompany: '{{name}} in neuem Tab öffnen',
    noProofOfCompany: 'Kein Unternehmensnachweis hochgeladen',
    proofLocationLoading: 'Adresse wird gesucht…',
    proofLocationViewMap: 'Auf der Karte ansehen',
    title: 'Administrationsbereich',
    verifications: 'Verifizierungen',
    advertisers: 'Werbetreibende',
    providers: 'Anbieter',
    payments: 'Zahlungen',
    noVerifications: 'Keine ausstehenden Verifizierungen',
    noPayments: 'Keine ausstehenden Zahlungen',
    markAsDone: 'Als erledigt markieren',
    business: 'Unternehmen',
    type: 'Typ',
    status: 'Status',
    actions: 'Aktionen',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    subtitle: 'Plattformverwaltung & Moderation',
    proofVerification: 'Manuelle Prüfungen',
    accessRequestsTab: 'Zugriffsanfragen',
    noAccessRequests: 'Keine ausstehenden Zugriffsanfragen.',
    noAdvertisers: 'Keine Werbetreibenden gefunden.',
    noProviders: 'Keine Anbieter gefunden.',
    noPaymentsStatus: 'Keine Zahlungen mit diesem Status.',
    campaignOutdoor: 'Kampagnen-Werbefläche: {{id}}',
    campaignFrom: 'Kampagne vom {{date}}',
    adCreative: 'Werbemittel',
    proofPhotos: 'Nachweisfotos ({{count}}) - Klicken, um in voller Größe zu öffnen',
    period: 'Zeitraum',
    outdoorsLabel: 'Werbeflächen',
    campaignsLabel: 'Kampagnen',
    spentLabel: 'ausgegeben',
    earnedLabel: 'eingenommen',
    markAsPaid: 'Als bezahlt markieren',
    tabAds: 'Anzeigen',
    tabBusinessProofs: 'Unternehmensnachweise',
    tabProofOfAds: 'Anzeigennachweise',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt',
    noAds: 'Keine ausstehenden Anzeigenprüfungen.',
    noBusinessProofs: 'Keine ausstehenden Unternehmensnachweise.',
    noProofOfAds: 'Keine ausstehenden Anzeigennachweise.',
    refundsTab: 'Erstattungen & Schulden',
    refundsSearchPlaceholder: 'Nach Kampagnen- oder Werbetreibendenname suchen…',
    refundsNoCampaigns: 'Keine Kampagnen gefunden.',
    refundsSelectOutdoors: 'Werbeflächen für Erstattung auswählen',
    refundsSelectAll: 'Alle auswählen',
    refundsDeselectAll: 'Alle abwählen',
    refundsNoEligible: 'Keine erstattungsfähigen Werbeflächen für diese Kampagne gefunden.',
    refundsEligibleNote: 'Nur nicht abgelehnte Werbeflächen sind erstattungsfähig.',
    refundsSubmit: 'Erstattung verarbeiten',
    refundsSuccess: 'Erstattung erfolgreich verarbeitet.',
    refundsSubTabRefunds: 'Werbetreibenden-Erstattungen',
    refundsSubTabDebts: 'Anbieterschulden',
    refundTypeTotal: 'Gesamt',
    refundTypePartial: 'Teilweise',
    refundDaysLabel: 'Zu erstattende Tage',
    refundDaysHint: 'Max. {{max}} Tage',
    debtNoDebts: 'Keine offenen Anbieterschulden.',
    debtSettle: 'Begleichen',
    debtSettleAmount: 'Abrechnungsbetrag',
    debtSettleDoc: 'Abrechnungsdokument',
    debtSettleDocHint: 'Unterzeichnetes Abrechnungsdokument hochladen (PDF, Bild usw.)',
    debtSettleConfirm: 'Hochladen & Begleichen',
    debtSettleSuccess: 'Schulden beglichen und Dokument erfolgreich hochgeladen.',
    debtStatusOutstanding: 'Ausstehend',
    debtStatusSettled: 'Beglichen',
    debtCampaign: 'Kampagne',
    campaignsTab: 'Kampagnen',
    noCampaigns: 'Keine Kampagnen gefunden.',
    accessRequestFor: 'Zugang angefordert zu: {{entity}}',
    tabByStatus: 'Nach Status',
    tabTransferRequested: 'Überweisung angefordert',
    checkPayment: 'Prüfen',
    lastCheckedAt: 'Zuletzt geprüft',
    neverChecked: 'Nie geprüft',
    noTransferRequested: 'Keine Zahlungen mit angeforderter Überweisung gefunden.',
    checkSuccess: 'Zahlungsprüfung eingeleitet.',
    revenueTitle: 'Einnahmen',
    revenueSubtitle: 'Plattformprovision und Mehrwertsteuer nach Abrechnungszeitraum',
    revenueGross: 'Bruttoumsatz',
    revenueCommission: 'Provision',
    revenueVat: 'MwSt.',
    revenueStripeFees: 'Stripe-Gebühren',
    revenueNet: 'Nettoumsatz',
    revenueEmpty: 'Keine Einnahmen für diesen Zeitraum erfasst.',
    revenueMonth: 'Monat',
    revenueYear: 'Jahr',
    revenueDailyTitle: 'Tagesübersicht',
    revenueNoDaily: 'Keine Tagesdaten für diesen Zeitraum.',
    searchByName: 'Nach Name suchen…',
    importOutdoorsFromFile: 'Außenwerbung aus Datei importieren',
    chooseFile: 'Datei auswählen…',
    csvSend: 'Senden',
    importOutdoorsSuccess: 'Außenwerbung-Datei erfolgreich gesendet.',
    remainingFreeCommissions: 'Verbleibende provisionsfreie Verkäufe: {{count}}',
    setFreeCommissions: 'Neue Anzahl provisionsfreier Verkäufe festlegen',
    freeCommissionsUpdated: 'Verbleibende provisionsfreie Verkäufe aktualisiert.',
    freeCommissionsUpdateFailed: 'Die verbleibenden provisionsfreien Verkäufe konnten nicht aktualisiert werden.',
    verified: 'Verifiziert',
  },
  ppCampaigns: {
    searchAllStatuses: 'Kampagnen in jedem Status werden angezeigt. Löschen Sie die Suche, um nach Status zu filtern.',
    typeAll: 'Alle',
    typeScapow: 'Scapow',
    typeOffline: 'Offline',
    typeFilterLabel: 'Kampagnentyp',
    noOfflineResults: 'Noch keine Offline-Kampagnen. Fügen Sie auf Ihrer Standorte-Seite Standorte zu einer hinzu.',
    goToOutdoors: 'Zu den Standorten',
    offlineBadge: 'Offline',
    moreOutdoors: '+{{count}} weitere',
    offlineNotes: 'Notizen',
    payoutCommission: 'Plattformprovision',
    payoutCommissionVat: 'MwSt. auf die Plattformprovision',
    payoutTransferred: 'Überwiesen',
    payoutValueWithoutVat: 'Werbewert (ohne MwSt.)',
    payoutVat: 'MwSt.',
    payoutProduction: 'Produktionskosten (inkl. MwSt.)',
    payoutsTitle: 'Auszahlungen',
    payoutsCount: 'Auszahlungen: {{count}}',
    payoutsReceived: 'Bisher erhalten',
    payoutFull: 'Gesamtauszahlung',
    payoutFirst: 'Erste Auszahlung · {{month}}',
    payoutAfterProof: 'Voraussichtlich ab {{date}}, nach Freigabe des Anzeigenachweises',
    payoutExpectedOn: 'Voraussichtlich am {{date}}',
    payoutReceivedOn: 'Erhalten am {{date}}',
    payoutProcessing: 'Überweisung läuft',
    payoutOnHold: 'Angehalten - die Lastschrift des Werbetreibenden ist fehlgeschlagen',
    payoutsOnHoldNotice: 'Eine Auszahlung ist angehalten, weil die Lastschrift des Werbetreibenden fehlgeschlagen ist. Sie wird freigegeben, sobald diese Zahlung erfolgt.',
    payoutsNetNote: 'Beträge abzüglich der Scapow-Provision und der darauf entfallenden MwSt., vor offenen Schulden.',
    colProduction: 'Produktion',
    title: 'Kampagnen',
    subtitle: 'Überwachen und verwalten Sie Kampagnen, die Ihre Outdoor-Flächen enthalten.',
    tabPending: 'Ausstehend',
    tabReady: 'Bereit',
    tabRunning: 'Laufend',
    tabCompleted: 'Abgeschlossen',
    noResults: 'Keine Kampagnen für diesen Status gefunden.',
    outdoorSlots: '{{count}} Outdoor-Fläche',
    outdoorSlots_plural: '{{count}} Outdoor-Flächen',
    instructions: 'Anweisungen des Werbetreibenden',
    backToCampaigns: 'Zurück zu den Kampagnen',
    yourSlots: 'Ihre Outdoor-Flächen',
    noSlots: 'Keine Outdoor-Flächen von Ihren Standorten in dieser Kampagne gefunden.',
    advertiserInstructions: 'Anweisungen des Werbetreibenden',
    messagesWithAdvertiser: 'Nachrichten mit dem Werbetreibenden',
    noConversation: 'Noch keine Nachrichten. Starten Sie eine Unterhaltung mit dem Werbetreibenden, indem Sie unten schreiben.',
    myInvoice: 'Meine Rechnung an den Werbetreibenden',
    uploadInvoice: 'Rechnung hochladen',
    replaceInvoice: 'Rechnung ersetzen',
    uploadInvoiceSuccess: 'Rechnung erfolgreich hochgeladen.',
    invoiceUploaded: 'Rechnung ansehen',
    noInvoiceYet: 'Noch keine Rechnung hochgeladen.',
    creativesAndOutdoors: 'Werbemittel & Ihre Flächen',
    noCreativeForRatio: 'Noch kein Werbemittel für dieses Format hochgeladen.',
    yourOutdoorsForFormat: 'Ihre Flächen für dieses Format',
    viewOutdoor: 'Fläche anzeigen',
    goToCampaign: 'Zur Kampagnenseite',
    yourEarnings: 'Ihre Einnahmen',
    readyPaymentTitle: 'Anzeigeüberprüfung erforderlich',
    readyPaymentNoteReady: 'Ihre Einnahmen sind gesichert und warten auf den Kampagnenstart. Sobald die Kampagne live ist, laden Sie für jede Werbefläche den Einrichtungsnachweis hoch, um die Zahlung auszulösen.',
    readyPaymentNote: 'Um Ihre Einnahmen freizugeben, laden Sie im Schritt „Anzeigen verifizieren" den Nachweis der Einrichtung für jede Werbefläche hoch.',
    readyPaymentCta: 'Zu „Anzeigen verifizieren"',
    paymentPaidTitle: 'Zahlung erhalten',
    paymentPaidDesc: 'Ihre Einnahmen für diese Kampagne wurden ausgezahlt.',
    viewBreakdown: 'Aufschlüsselung anzeigen',
    earningsBreakdown: 'Einnahmenaufschlüsselung',
    colDays: 'Tage',
    colNetDailyValue: 'Tageswert + MwSt.',
    colEarnings: 'Einnahmen',
  },
  upcomingCampaigns: {
    title: 'Bevorstehende Kampagnen',
    subtitle: 'Kampagnen, die Ihre Werbeflächen umfassen und startbereit sind.',
    noResults: 'Keine bevorstehenden Kampagnen gefunden.',
  },
  getPaid: {
    title: 'Bezahlung Erhalten',
    subtitle: 'Folgen Sie den Schritten, um Ihre Plakatierungen zu verifizieren und eine Zahlung zu erhalten.',
    step1: { label: 'Bevorstehende Kampagnen', desc: 'Holen Sie sich die Creatives zur Einrichtung der Werbeflächen' },
    step2: { label: 'Flächen Verifizieren', desc: 'Nachweis der Anzeige hochladen, um bezahlt zu werden' },
    step3: { label: 'Bezahlte Rechnungen', desc: 'Ihre Zahlungshistorie' },
    paidOn: 'Bezahlt am',
    downloadInvoice: 'Rechnung',
    noPayments: 'Noch keine Zahlungen',
    noPaymentsDesc: 'Schließen Sie den Verifizierungsschritt ab, um die Zahlung freizuschalten.',
    upcomingEmpty: 'Derzeit keine bevorstehenden Kampagnen. Schauen Sie später vorbei.',
    goToVerify: 'Zu Flächen Verifizieren',
    goToPaid: 'Zahlungen ansehen',
    goToUpcoming: 'Bevorstehende Kampagnen ansehen',
  },
  cart: {
    title: 'Ihr Warenkorb',
    empty: 'Ihr Warenkorb ist leer',
    emptyDesc:
      'Suchen Sie nach Werbeflächen und fügen Sie sie dem Warenkorb hinzu, um eine Kampagne zu erstellen.',
    browseOutdoors: 'Werbeflächen erkunden',
    campaignDetails: 'Kampagnendetails',
    campaignName: 'Kampagnenname',
    description: 'Beschreibung (optional)',
    subtotal: 'Zwischensumme',
    total: 'Gesamt',
    remove: 'Entfernen',
    placeOrder: 'Kampagne erstellen',
    creating: 'Wird erstellt…',
    estimatedCost: 'Geschätzte Kosten',
    signInTitle: 'Anmelden, um fortzufahren',
    signInDesc: 'Erstellen Sie ein Konto oder melden Sie sich an, um Ihre Kampagne zu erstellen.',
    buildCampaign: 'Kampagne erstellen',
    estimatedTotal: 'Geschätztes Gesamtbudget',
    campaignNamePlaceholder: 'Kampagne Sommer 2026',
    detailsPlaceholder: 'Irgendwelche Anmerkungen...',
    campaignLabel: 'Kampagne {{n}}',
    selectCampaign: 'Zur Kampagne hinzufügen:',
    signInToCheckout: 'Anmelden, um diese Kampagne zu erstellen',
    advertiserRequired: 'Sie benötigen ein Inserenten-Konto, um Kampagnen zu erstellen',
    instructions: 'Anweisungen für Werbeflächen-Anbieter (optional)',
    instructionsPlaceholder: 'Besondere Anweisungen für Werbeflächen-Anbieter kommen hier hin...',
    instructionsHint: 'Sie können dieses Feld nach der Kampagnenerstellung aktualisieren.',
  },
  invitations: {
    title: 'Benutzereinladungen',
    subtitle: 'Einladungen für Teammitglieder Ihres Unternehmens verwalten',
    pendingTitle: 'Ausstehende Einladungen',
    noPending: 'Keine ausstehenden Einladungen',
    noPendingDesc: 'Laden Sie oben ein Teammitglied ein, um zu beginnen.',
    sentAt: 'Gesendet',
    cancel: 'Abbrechen',
    inviteSuccess: 'Einladung erfolgreich gesendet.',
    inviteError: 'Einladung konnte nicht gesendet werden.',
    cancelSuccess: 'Einladung abgebrochen.',
    formTitle: 'Teammitglied einladen',
    formDesc: 'Sie erhalten eine E-Mail mit einem Link, um Ihrem Unternehmen bei Scapow beizutreten.',
    formPlaceholder: 'kollege@unternehmen.com',
    formSend: 'Einladung senden',
  },
  terms: {
    back: 'Zurück',
    title: 'Allgemeine Geschäftsbedingungen',
    effectiveDate: 'Gültig ab: 19. Juni 2026 · SCAPOW · Codify, Unipessoal Lda',
    introBanner: 'Durch die Registrierung eines Kontos, den Zugriff auf oder die Nutzung der Plattform erklären Sie sich damit einverstanden, rechtlich an diese Bedingungen gebunden zu sein. Wenn Sie nicht einverstanden sind, dürfen Sie die Plattform nicht nutzen.',
    footerNote: 'SCAPOW · Codify, Unipessoal Lda · Gültig ab 19. Juni 2026',
    s1: 'Einleitung',
    s1_p1: 'Diese Allgemeinen Geschäftsbedingungen („Bedingungen") regeln den Zugang zu und die Nutzung der SCAPOW-Plattform („Plattform"), betrieben von Codify, Unipessoal Lda („Unternehmen", „wir", „unser", „uns").',
    s1_p2: 'Die Plattform fungiert als digitaler Marktplatz, der folgende Parteien verbindet:',
    s1_i1Bold: 'Werbetreibende',
    s1_i1Rest: ', die Werbeflächen für Marketingkampagnen erwerben möchten; und',
    s1_i2Bold: 'Flächenanbieter',
    s1_i2Rest: ', die physische Werbeflächen besitzen, betreiben oder kontrollieren, einschließlich, aber nicht beschränkt auf Plakatwände, Außenwerbetafeln, digitale Displays und andere Medienplatzierungen.',
    s2: 'Voraussetzungen',
    s2_p1: 'Nutzer müssen:',
    s2_i1: 'Mindestens 18 Jahre alt sein;',
    s2_i2: 'Die Rechtsfähigkeit besitzen, verbindliche Vereinbarungen zu schließen;',
    s2_i3: 'Bei der Registrierung genaue und vollständige Angaben machen;',
    s2_i4: 'Alle geltenden Gesetze und Vorschriften einhalten.',
    s2_p2: 'Geschäftliche Nutzer versichern, dass sie berechtigt sind, ihr Unternehmen oder ihre Organisation zu verpflichten.',
    s3: 'Nutzerrollen',
    s3_1: '3.1 Werbetreibende',
    s3_1_p1: 'Werbetreibende können:',
    s3_1_i1: 'Werbeplatzierungen suchen, auswählen und erwerben;',
    s3_1_i2: 'Werbematerialien hochladen;',
    s3_1_i3: 'Kampagnen starten und verwalten.',
    s3_1_p2: 'Werbetreibende sind allein verantwortlich für:',
    s3_1_i4: 'Die Rechtmäßigkeit ihrer Werbeinhalte;',
    s3_1_i5: 'Die Eigentümerschaft oder Genehmigung aller verwendeten geistigen Eigentumsrechte;',
    s3_1_i6: 'Die Einhaltung der Werbegesetze.',
    s3_2: '3.2 Flächenanbieter',
    s3_2_p1: 'Flächenanbieter können:',
    s3_2_i1: 'Verfügbare Werbeflächen anbieten;',
    s3_2_i2: 'Preise, Kampagnenverfügbarkeit und betriebliche Anforderungen festlegen;',
    s3_2_i3: 'Kampagnenplatzierungen annehmen.',
    s3_2_p2: 'Flächenanbieter erklären und garantieren, dass sie:',
    s3_2_i4: 'Die Werbefläche besitzen oder rechtmäßig kontrollieren;',
    s3_2_i5: 'Alle Genehmigungen, Lizenzen und Rechte für die kommerzielle Werbenutzung besitzen;',
    s3_2_i6: 'Gebuchte Kampagnen innerhalb der vereinbarten Fristen erfüllen können.',
    s3_3: '3.3 Rechtliche Erklärung für die Auflistung von Werbeflächen',
    s3_3_p1: 'Bei der Auflistung einer Außenwerbefläche auf der Plattform muss jeder Flächenanbieter zum Zeitpunkt der Einreichung ausdrücklich bestätigen, dass:',
    s3_3_i1: 'Er die Rechte an der eingereichten Werbefläche besitzt;',
    s3_3_i2: 'Er berechtigt ist, sie für kommerzielle Zwecke anzubieten;',
    s3_3_i3: 'Die Auflistung allen geltenden Gesetzen, Genehmigungen, Lizenzen, Zonierungsvorschriften und Anforderungen der lokalen Behörden entspricht.',
    s3_3_p2: 'Diese Erklärung ist Voraussetzung für die Auflistung. Einreichungen ohne diese Bestätigung werden nicht akzeptiert. Die Plattform behält sich das Recht vor, jede Auflistung zu entfernen, bei der die Erklärung als falsch oder irreführend befunden wird, und das Konto jedes Flächenanbieters zu sperren oder zu kündigen, der ungenaue Angaben macht.',
    s4: 'Rolle der Plattform',
    s4_p1: 'Die Plattform agiert ausschließlich als Vermittler und Facilitator. Das Unternehmen:',
    s4_i1: 'Besitzt keine Werbeflächen;',
    s4_i2: 'Agiert nicht als Werbetreibender oder Flächenanbieter;',
    s4_i3: 'Garantiert keine Kampagnenleistung, Impressionen oder Geschäftsergebnisse;',
    s4_i4: 'Ist nicht verantwortlich für die physische Installation oder Entfernung von Werbemitteln.',
    s4_p2: 'Jede Transaktion begründet eine direkte vertragliche Beziehung zwischen dem Werbetreibenden und dem Flächenanbieter.',
    s5: 'Kampagnenbuchungen',
    s5_p1: 'Eine Kampagnenbuchung wird verbindlich, sobald:',
    s5_i1: 'Der Werbetreibende hat den Checkout abgeschlossen - durch vollständige Zahlung oder, bei einer in Raten bezahlten Kampagne, durch Autorisierung der ersten Zahlung und der Lastschrift für die folgenden Raten;',
    s5_i2: 'Jeder Werbestandort ist bestätigt - sofort bei sofort buchbaren Standorten oder durch seinen Flächenanbieter innerhalb der Bestätigungsfrist;',
    s5_i3: 'Das Kampagnenstartdatum geplant ist.',
    s5_p2: 'Alle Buchungen unterliegen der vom Flächenanbieter festgelegten Mindestvorlaufzeit. Diese bestimmt den spätestmöglichen Zeitpunkt, zu dem ein Werbetreibender eine Kampagne einreichen und bezahlen darf. Nichteinhaltung kann zur Ablehnung oder Verschiebung führen.',
    s6: 'Zahlungsbedingungen',
    s6_1: '6.1 Zahlungen der Werbetreibenden',
    s6_1_p1: 'Werbetreibende zahlen gemäß dem beim Checkout gewählten Zahlungsplan:',
    s6_1_i1: 'Vollständige Zahlung - der gesamte Kampagnenbetrag wird beim Checkout belastet;',
    s6_1_i2: 'Monatlich oder alle drei Monate - die Produktionskosten und der erste Abrechnungszeitraum werden beim Checkout belastet, jeder weitere Abrechnungszeitraum wird an seinem ersten Tag per Lastschrift eingezogen. Diese Pläne sind nur verfügbar, wenn die Kampagne über ihren ersten Abrechnungszeitraum hinausgeht.',
    s6_1_p2: 'Der Checkout muss vor dem Kampagnenstart und vor Ablauf der Mindest-Vorankündigungsfrist des Flächenanbieters abgeschlossen werden. Erfordern Werbestandorte eine Bestätigung, wird die Zahlung beim Checkout nur autorisiert und erst nach deren Bestätigung belastet, und ausschließlich für die bestätigten Standorte. Zahlungsverzug bei einer Rate richtet sich nach Abschnitt 6.4. Wird der Checkout nicht rechtzeitig abgeschlossen:',
    s6_1_i3: 'Kann die Buchung automatisch storniert werden;',
    s6_1_i4: 'Ist der Flächenanbieter nicht verpflichtet, die Werbefläche zu reservieren.',
    s6_2: '6.2 Plattformgebühren',
    s6_2_p1: 'Die Plattform kann Servicegebühren, Provisionen oder Transaktionsgebühren erheben. Diese werden vor dem Kauf offengelegt. Plattformgebühren sind nicht erstattungsfähig, sofern gesetzlich nicht anders vorgeschrieben.',
    s6_3: '6.3 Auszahlungen an Flächenanbieter',
    s6_3_p1: 'Flächenanbieter werden erst nach folgenden Voraussetzungen zahlungsberechtigt:',
    s6_3_i1: 'Die Werbematerialien wurden vollständig installiert;',
    s6_3_i2: 'Der Installationsnachweis wurde über die Plattform hochgeladen;',
    s6_3_i3: 'Dieser Nachweis wurde genehmigt oder innerhalb der geltenden Prüffrist nicht angefochten.',
    s6_3_p2: 'Der Nachweis muss klare fotografische Belege enthalten, die die korrekte Anzeige der Kampagne zeigen. Die Plattform behält sich das Recht vor, die Echtheit zu prüfen. Zahlungen können bei Betrug, Streitigkeiten oder Nichterfüllung verzögert, einbehalten oder rückgängig gemacht werden.',
    s6_4: '6.4 Zahlungspflichten und Zahlungsverzug',
    s6_4_p1: 'Jede bestätigte Buchung begründet eine verbindliche Zahlungspflicht des Werbetreibenden. Der Werbetreibende hat sämtliche Beträge für die von ihm gebuchten Kampagnen und Werbestandorte vollständig und fristgerecht zu zahlen, einschließlich jeder Rate einer in Raten (monatlich oder alle drei Monate) bezahlten Kampagne.',
    s6_4_i1: 'Jeder bis zum Fälligkeitsdatum nicht gezahlte Betrag - einschließlich einer abgelehnten, zurückgegebenen oder rückgängig gemachten Lastschrift - ist ab diesem Datum überfällig. Die Plattform benachrichtigt den Werbetreibenden und kann den Einzug erneut versuchen.',
    s6_4_i2: 'Bleibt ein Betrag im Zusammenhang mit einer Kampagne länger als zwei (2) Monate nach Fälligkeit unbezahlt, kann der Flächenanbieter ohne Haftung gegenüber dem Werbetreibenden dessen Werbemittel von den betroffenen Werbestandorten entfernen und diese Standorte anderen Werbetreibenden zur Verfügung stellen.',
    s6_4_i3: 'Eine solche Entfernung entbindet den Werbetreibenden nicht von seinen Verpflichtungen: Alle bereits fälligen Beträge sowie etwaige Gebühren nach Abschnitt 9.3 bleiben in voller Höhe zahlbar.',
    s6_4_i4: 'Die Plattform und/oder der Flächenanbieter können rechtliche Schritte zur Beitreibung ausstehender Beträge einleiten, zuzüglich Verzugszinsen in Höhe des anwendbaren gesetzlichen Zinssatzes sowie angemessener Beitreibungs- und Rechtsverfolgungskosten, soweit nach geltendem Recht zulässig.',
    s6_4_i5: 'Die Plattform kann zudem das Konto des Werbetreibenden sperren und neue Buchungen ablehnen, bis alle überfälligen Beträge beglichen sind, gemäß Abschnitt 15.',
    s6_4_p2: 'Die Entfernung von Werbemitteln nach diesem Abschnitt stellt keine Nichterfüllung des Flächenanbieters im Sinne der Abschnitte 9.4 und 9.5 dar und begründet keinen Erstattungsanspruch.',
    s7: 'Kampagnenmaterialien',
    s7_p1: 'Werbetreibende müssen Kampagnenmaterialien innerhalb der erforderlichen Frist einreichen. Materialien müssen:',
    s7_i1: 'Technische Spezifikationen erfüllen;',
    s7_i2: 'Druckfähig und verwendbar sein;',
    s7_i3: 'Geltenden Gesetzen entsprechen;',
    s7_i4: 'Keine illegalen, diffamatorischen, anstößigen oder rechtsverletzenden Inhalte enthalten.',
    s7_p2: 'Flächenanbieter können nicht konforme Materialien ablehnen. Die Plattform kann Inhalte nach eigenem Ermessen entfernen.',
    s8: 'Installationsnachweis',
    s8_p1: 'Flächenanbieter müssen den Installationsnachweis umgehend nach der Installation hochladen. Fehlt der Nachweis, kann dies führen zu:',
    s8_i1: 'Verzögerter Zahlung;',
    s8_i2: 'Stornierung der Auszahlung;',
    s8_i3: 'Sperrung von der Plattform.',
    s8_p2: 'Werbetreibende können den Nachweis innerhalb des geltenden Anfechtungszeitraums nach dem Upload anfechten. Erfolgt keine Anfechtung innerhalb dieser Frist, gilt der Nachweis als akzeptiert.',
    s9: 'Stornierungen und Rückerstattungen',
    s9_1: '9.1 Stornierung durch den Werbetreibenden',
    s9_1_p1: 'Wenn ein Werbetreibender storniert:',
    s9_1_i1: 'Vor der Mindestvorlaufzeit des Flächenanbieters: Rückerstattung möglich, abzüglich anfallender Gebühren;',
    s9_1_i2: 'Nach Beginn der Vorlaufzeit: Rückerstattung kann abgelehnt werden.',
    s9_1_p2: 'Produktions-, Druck- und Vorbereitungskosten können nicht erstattungsfähig sein.',
    s9_2: '9.2 Stornierung durch den Flächenanbieter',
    s9_2_p1: 'Wenn ein Flächenanbieter eine bestätigte Buchung ohne triftigen Grund storniert:',
    s9_2_i1: 'Erhält der Werbetreibende eine vollständige Rückerstattung;',
    s9_2_i2: 'Kann der Flächenanbieter Strafen, reduzierte Sichtbarkeit, Sperrung oder Kontokündigung erleiden.',
    s9_3: '9.3 Stornierungsrichtlinie für Kampagnen',
    s9_3_i1: 'Kampagnen im Status „Ausstehend" können jederzeit vor der Zahlung kostenlos storniert werden.',
    s9_3_i5: 'Liegt das Stornierungsdatum für jede Outdoor-Aktivierung mehr Tage vor dem Startdatum, als die Mindest-Vorankündigungsfrist des jeweiligen Flächenanbieters beträgt, fällt keine Stornierungsgebühr an und der Werbetreibende erhält eine vollständige Rückerstattung aller geleisteten Zahlungen.',
    s9_3_i2: 'Nach erfolgter Zahlung fällt eine Stornierungsgebühr von 30 % des Gesamtkampagnenwerts an, sofern eine oder mehrere Outdoor-Aktivierungen der Kampagne in die Mindest-Vorankündigungsfrist des jeweiligen Flächenanbieters fallen.',
    s9_3_i3: 'Für in Portugal ansässige Unternehmen wird auf die Stornierungsgebühr der geltende Mehrwertsteuersatz erhoben.',
    s9_3_i4: 'Fallen eine oder mehrere Outdoor-Aktivierungen in die Mindest-Vorankündigungsfrist des Flächenanbieters, sind Einrichtungs- und Druckkosten nicht erstattungsfähig.',
    s9_3_i6: 'Die Stornierung einer bereits laufenden Kampagne führt zum vollständigen Verlust von 100 % des Kampagnenwerts. Eine Rückerstattung wird nicht gewährt.',
    s9_3_i7: 'Sofern die Stornierungsgebühr von 30 % anfällt, werden 20 % des Gesamtkampagnenwerts an die jeweiligen Flächenanbieter überwiesen, abzüglich der standardmäßigen Plattformgebühr von 5 % und der anwendbaren Mehrwertsteuer.',
    s9_4: '9.4 Erstattung bei nicht nachgewiesenen Placements',
    s9_4_p1: 'Sofern ein Flächenanbieter keinen gültigen Nachweis der Schaltung für eine oder mehrere Werbeflächen innerhalb der erforderlichen Frist einreicht, erstattet Scapow dem Werbetreibenden wie folgt:',
    s9_4_i1: 'Für jeden Tag innerhalb des Kampagnenzeitraums, an dem eine Werbefläche die Kreative des Werbetreibenden nicht anzeigt, wird dem Werbetreibenden der anteilige Tageswert dieser Werbefläche erstattet.',
    s9_4_i4: 'Auf den insgesamt für ausgefallene Tage erstatteten Betrag wird eine Stornogebühr von 10 % zuzüglich der geltenden MwSt. erhoben.',
    s9_4_i2: 'Die Rückerstattung wird innerhalb einer angemessenen Frist nach Bestätigung verarbeitet, dass kein Nachweis der Schaltung erbracht oder dieser als ungültig eingestuft wurde.',
    s9_4_i3: 'Plattformgebühren für nachgewiesene und erfüllte Placements bleiben nicht erstattungsfähig.',
    s9_5: '9.5 Nichterfüllung durch Flächenanbieter - Teilweise Kampagnendurchführung',
    s9_5_p1: 'Erfüllt ein Flächenanbieter seine Verpflichtung nicht, die Werbematerialien des Werbetreibenden für die gesamte vereinbarte Kampagnenlaufzeit zu schalten, gilt jeder Tag, an dem die vereinbarte Anzeigeverpflichtung nicht erfüllt wird, als „Nichterfüllungstag".',
    s9_5_a: 'a) Finanzielle Haftung gegenüber Scapow',
    s9_5_p2: 'Für jeden Nichterfüllungstag haftet der Flächenanbieter gegenüber der Plattform für einen Betrag in Höhe des täglichen Werbewerts, der dem jeweiligen Kampagnenplatz zuzuordnen ist (der „Nichterfüllungsbetrag"). Die Einziehung des Nichterfüllungsbetrags erfolgt nach alleinigem Ermessen der Plattform durch eine oder mehrere der folgenden Maßnahmen:',
    s9_5_i1: '(i) Aufforderung an den Flächenanbieter, den Nichterfüllungsbetrag innerhalb der in einer schriftlichen Mitteilung der Plattform angegebenen Frist direkt an die Plattform zu entrichten; oder',
    s9_5_i2: '(ii) Abzug des Nichterfüllungsbetrags von aktuellen oder zukünftigen Kampagnenauszahlungen, die dem Flächenanbieter zustehen, ob im Rahmen derselben Kampagne oder einer späteren Zusammenarbeit auf der Plattform.',
    s9_5_p3: 'Die Plattform behält sich das Recht vor, beide Maßnahmen gleichzeitig anzuwenden, soweit dies zur vollständigen Einziehung des gesamten Nichterfüllungsbetrags erforderlich ist.',
    s9_5_b: 'b) Vollständige Rückerstattung an den Werbetreibenden',
    s9_5_p4: 'Für jeden Nichterfüllungstag hat der Werbetreibende Anspruch auf vollständige Rückerstattung aller für diese Tage geleisteten Zahlungen, einschließlich des entsprechenden täglichen Kampagnenwerts, aller anwendbaren Plattformprovisionen sowie aller diesen Tagen zuzurechnenden Service- oder Transaktionsgebühren. Die Rückerstattung wird von der Plattform innerhalb einer angemessenen Frist nach bestätigter Feststellung der Nichterfüllung bearbeitet.',
    s9_5_c: 'c) Feststellung der Nichterfüllung',
    s9_5_p5: 'Die Nichterfüllung der vereinbarten Anzeigedauer wird anhand von über die Plattform eingereichten Nachweisen bewertet, einschließlich, aber nicht beschränkt auf Schaltungsnachweise, Berichte der Werbetreibenden, fotografische Dokumentation und sonstiges Material, das die Plattform für relevant erachtet. Die Feststellung der Plattform ist für die Berechnung des Nichterfüllungsbetrags und die Abwicklung von Rückerstattungen an Werbetreibende endgültig und bindend, unbeschadet der gesetzlichen Rechte beider Parteien nach anwendbarem Recht.',
    s9_6: '9.6 Höhere Gewalt - Naturkatastrophen',
    s9_6_p1: 'Ein „Ereignis höherer Gewalt" ist eine Naturkatastrophe oder ein damit zusammenhängender Notfall außerhalb der zumutbaren Kontrolle des Werbetreibenden und des Flächenanbieters, die bzw. der einen Werbestandort physisch daran hindert, das Werbemittel des Werbetreibenden anzuzeigen, oder die Anzeige unsicher macht - einschließlich Erdbeben, Überschwemmungen, Stürmen, Orkanen, Waldbränden, Erdrutschen, von den zuständigen Behörden erlassenen Evakuierungs- oder Notfallanordnungen sowie durch solche Ereignisse verursachter Stromausfälle. Gewöhnliche widrige Witterung, normaler Verschleiß und mangelnde Wartung sind keine Ereignisse höherer Gewalt.',
    s9_6_a: 'a) Meldung und Nachweis',
    s9_6_p2: 'Der Flächenanbieter muss ein Ereignis höherer Gewalt innerhalb von 48 Stunden, nachdem er davon Kenntnis erlangt hat, über die Plattform melden, zusammen mit Nachweisen (etwa Fotos oder amtlichen Warnungen) und einem voraussichtlichen Wiederherstellungsdatum. Die Plattform prüft anhand dieser Nachweise, ob das Ereignis anerkannt wird; ihre Entscheidung ist für die Zwecke dieses Abschnitts endgültig und verbindlich.',
    s9_6_b: 'b) Folgen für den Flächenanbieter',
    s9_6_i1: 'Jeder Tag, an dem die Anzeige durch ein anerkanntes Ereignis höherer Gewalt verhindert wird (ein „Tag höherer Gewalt"), gilt nicht als Tag der Nichterfüllung im Sinne von Abschnitt 9.5, und es ist dafür kein Nichterfüllungsbetrag geschuldet.',
    s9_6_i2: 'Für Tage höherer Gewalt ist dem Flächenanbieter keine Auszahlung geschuldet.',
    s9_6_i3: 'Der Flächenanbieter muss die Anzeige innerhalb von 5 Werktagen nach dem Ende des Ereignisses höherer Gewalt wiederherstellen. Jeder Tag nach Ablauf dieser Frist, an dem die Anzeige nicht wiederhergestellt ist, gilt als Tag der Nichterfüllung im Sinne von Abschnitt 9.5.',
    s9_6_i4: 'Der Flächenanbieter bleibt für die Instandhaltung und eine angemessene Versicherung seiner Strukturen verantwortlich, einschließlich der Kosten für Neudruck und Neuanbringung von Werbemitteln, die durch das Ereignis beschädigt oder zerstört wurden.',
    s9_6_c: 'c) Folgen für den Werbetreibenden',
    s9_6_i5: 'Der Werbetreibende hat Anspruch auf vollständige Erstattung aller für Tage höherer Gewalt gezahlten Beträge, einschließlich des täglichen Kampagnenpreises, der entsprechenden Plattformprovision und der anwendbaren MwSt., ohne die in Abschnitt 9.4 genannte Gebühr von 10 %.',
    s9_6_i6: 'Alternativ kann der Werbetreibende die betroffenen Tage an das Ende der Kampagne verschieben lassen, vorbehaltlich der Verfügbarkeit des Werbestandorts.',
    s9_6_i7: 'Wird ein Werbestandort vor Beginn seiner Aktivierung aufgrund eines Ereignisses höherer Gewalt nicht verfügbar, können der Werbetreibende oder der Flächenanbieter ihn ungeachtet von Abschnitt 9.3 ohne Stornogebühr aus der Kampagne entfernen, und der Werbetreibende erhält die dafür gezahlten Beträge vollständig erstattet.',
    s9_6_i8: 'Dauert ein Ereignis höherer Gewalt länger als 14 Tage oder länger als die Hälfte des verbleibenden Kampagnenzeitraums des betroffenen Standorts, kann der Werbetreibende den Rest dieses Standorts kostenfrei stornieren und erhält die verbleibenden Tage erstattet.',
    s9_6_i9: 'Bei Kampagnen mit monatlichen Raten werden künftige Raten entsprechend reduziert oder gestrichen.',
    s9_6_d: 'd) Geltungsbereich',
    s9_6_p3: 'Ereignisse, die nur den eigenen Geschäftsbetrieb des Werbetreibenden und nicht die Werbestandorte betreffen, fallen nicht unter diesen Abschnitt; es gilt die Kampagnen-Stornierungsrichtlinie in Abschnitt 9.3.',
    s9_7: '9.7 Vandalismus',
    s9_7_p1: '„Vandalismus" bezeichnet die vorsätzliche Beschädigung, Verunstaltung oder Entfernung eines Werbestandorts oder des Werbemittels des Werbetreibenden durch Dritte ohne Verbindung zum Werbetreibenden oder zum Flächenanbieter - zum Beispiel Graffiti, abgerissene oder überklebte Plakate oder beschädigte Bildschirme oder Strukturen.',
    s9_7_i1: 'Der Flächenanbieter muss Vandalismus innerhalb von 48 Stunden, nachdem er davon Kenntnis erlangt hat, über die Plattform melden, zusammen mit Fotos und, sofern vorhanden, einer polizeilichen Anzeige.',
    s9_7_i2: 'Der Flächenanbieter muss die Anzeige innerhalb von 3 Werktagen nach der Meldung auf eigene Kosten wiederherstellen, einschließlich Neudruck und Neuanbringung des Werbemittels.',
    s9_7_i3: 'Tage, an denen die Anzeige innerhalb dieser Wiederherstellungsfrist verhindert ist, werden als Tage höherer Gewalt im Sinne von Abschnitt 9.6 behandelt: Der Werbetreibende hat Anspruch auf deren vollständige Erstattung ohne Gebühren, und es ist kein Nichterfüllungsbetrag geschuldet.',
    s9_7_i4: 'Tage nach Ablauf der Wiederherstellungsfrist sowie Vandalismus, der darauf beruht, dass der Flächenanbieter keine zumutbaren Vorbeugemaßnahmen getroffen hat, gelten als Tage der Nichterfüllung im Sinne von Abschnitt 9.5.',
    s9_7_i5: 'Wird derselbe Werbestandort innerhalb von 30 Tagen dreimal oder öfter beschädigt, muss der Flächenanbieter zumutbare Vorbeugemaßnahmen treffen, und der Werbetreibende kann den Rest dieses Standorts kostenfrei stornieren und erhält die verbleibenden Tage erstattet.',
    s9_7_p2: 'Die Meldung eines Ereignisses höherer Gewalt oder von Vandalismus, das bzw. der nicht stattgefunden hat, wird als Einreichung eines falschen Anzeigenachweises im Sinne von Abschnitt 12 behandelt und kann zur sofortigen Sperrung oder Kündigung des Kontos führen.',
    proofProtectionNote: 'Ihre Investition ist geschützt: Wenn ein Outdoor-Placement keinen verifizierten Schaltungsnachweis erbringt, erstattet Scapow den entsprechenden Betrag für dieses Placement.',
    s10: 'Streitigkeiten',
    s10_p1: 'Nutzer verpflichten sich, zunächst eine Lösung über die Plattform zu versuchen. Die Plattform kann:',
    s10_i1: 'Kampagnenbeweise prüfen;',
    s10_i2: 'Zusätzliche Dokumentation anfordern;',
    s10_i3: 'Eine unverbindliche Entscheidung treffen.',
    s10_p2: 'Die Entscheidung der Plattform ersetzt keine gesetzlichen Rechte nach geltendem Recht.',
    s11: 'Geistiges Eigentum',
    s11_p1: 'Werbetreibende behalten das Eigentum an ihren eingereichten Inhalten.',
    s11_p2: 'Durch das Hochladen von Materialien gewähren Werbetreibende der Plattform und den Flächenanbietern eine eingeschränkte, nicht exklusive Lizenz zur Nutzung, Vervielfältigung und Anzeige dieser Materialien ausschließlich zur Durchführung der Kampagne.',
    s11_p3: 'Flächenanbieter behalten das Eigentum an ihren Inseraten, Bildern und Standortdaten.',
    s11_p4: 'Die Plattform behält das Eigentum an der gesamten Plattformsoftware, Markenzeichen und Systemen.',
    s12: 'Verbotene Nutzung',
    s12_p1: 'Nutzer dürfen nicht:',
    s12_i1: 'Betrug begehen;',
    s12_i2: 'Irreführende oder illegale Inhalte hochladen;',
    s12_i3: 'Zahlungen umgehen;',
    s12_i4: 'Nutzer außerhalb der Plattform kontaktieren, um Gebühren zu vermeiden;',
    s12_i5: 'Bewertungen oder Kampagnenergebnisse manipulieren;',
    s12_i6: 'Falschen Installationsnachweis hochladen.',
    s12_p2: 'Verstöße können zur sofortigen Sperrung oder Kündigung führen.',
    s13: 'Haftung',
    s13_p1: 'Im gesetzlich zulässigen Höchstmaß haftet die Plattform nicht für:',
    s13_i1: 'Schlechte Kampagnenleistung;',
    s13_i2: 'Witterungsschäden, Naturkatastrophen und Vandalismus, die in den Abschnitten 9.6 und 9.7 geregelt sind;',
    s13_i3: 'Durch Dritte verursachte Verzögerungen;',
    s13_i4: 'Druckfehler, die nicht von der Plattform verursacht wurden;',
    s13_i5: 'Handlungen oder Unterlassungen der Nutzer.',
    s13_p2: 'Die Gesamthaftung übersteigt nicht die an die Plattform gezahlten Gesamtgebühren für die betreffende Kampagne.',
    s14: 'Schadloshaltung',
    s14_p1: 'Nutzer verpflichten sich, das Unternehmen gegen jegliche Ansprüche, Verluste, Schäden, Verbindlichkeiten oder Ausgaben, die entstehen aus, schadlos zu halten:',
    s14_i1: 'Verletzung dieser Bedingungen;',
    s14_i2: 'Illegalen Werbeinhalten;',
    s14_i3: 'Verletzung von Rechten Dritter;',
    s14_i4: 'Betrügerischem Verhalten.',
    s15: 'Kontosperrung',
    s15_p1: 'Die Plattform kann Konten sperren oder kündigen wegen:',
    s15_i1: 'Betrug;',
    s15_i2: 'Nichtzahlung;',
    s15_i3: 'Wiederholter Streitigkeiten;',
    s15_i4: 'Missbrauch der Plattform;',
    s15_i5: 'Verletzung dieser Bedingungen.',
    s16: 'Steuern',
    s16_p1: 'Nutzer sind für ihre eigenen Steuern verantwortlich, einschließlich Mehrwertsteuer, Umsatzsteuer, Einkommensteuer und anderer anwendbarer Steuern. Die Plattform kann Steuern erheben, sofern gesetzlich vorgeschrieben.',
    s17: 'Datenschutz',
    s17_p1: 'Nutzerdaten werden gemäß der Datenschutzrichtlinie der Plattform und den geltenden Datenschutzgesetzen verarbeitet. Nutzer sind dafür verantwortlich, dass sie die gesetzlichen Rechte an allen hochgeladenen personenbezogenen Daten besitzen.',
    s18: 'Anwendbares Recht',
    s18_p1: 'Diese Bedingungen unterliegen dem geltenden Recht ohne Rücksicht auf Grundsätze des internationalen Privatrechts. Streitigkeiten unterliegen der ausschließlichen Zuständigkeit der zuständigen Gerichte.',
    s19: 'Änderungen',
    s19_p1: 'Die Plattform kann diese Bedingungen jederzeit ändern. Die fortgesetzte Nutzung der Plattform nach Änderungen gilt als Zustimmung.',
    s20: 'Kontakt',
    s20_p1: 'Für rechtliche Anfragen:',
  },
  team: {
    title: 'Teamverwaltung',
    subtitle: 'Verwalte deine Teammitglieder und sende Einladungen',
    tabUsers: 'Aktive Mitglieder',
    tabInvitations: 'Einladungen',
    noUsers: 'Noch keine aktiven Mitglieder',
    noUsersDesc: 'Benutzer erscheinen hier, sobald sie die Einladung angenommen haben',
    statusVerified: 'Verifiziert',
    statusPending: 'Ausstehend',
  },
  footer: {
    tagline:
      'Der Marktplatz, der Außenwerbeflächenbesitzer mit Werbetreibenden verbindet. Einfach, effizient, wirkungsvoll.',
    platform: 'Plattform',
    browseOutdoors: 'Werbeflächen erkunden',
    createAccount: 'Konto erstellen',
    logIn: 'Anmelden',
    forBusinesses: 'Für Unternehmen',
    registerBusiness: 'Unternehmen registrieren',
    listOutdoors: 'Werbeflächen einstellen',
    runCampaigns: 'Kampagnen schalten',
    about: 'Über uns',
    howItWorks: 'So funktioniert es',
    mission: 'Unsere Mission',
    contactUs: 'Kontakt',
    copyright: '© 2026 Scapow by Codify. Alle Rechte vorbehalten.',
    privacy: 'Datenschutz',
    terms: 'AGB',
  },
  language: {
    select: 'Sprache',
    en: 'English',
    pt: 'Português',
    es: 'Español',
    de: 'Deutsch',
    zh: '中文',
    ja: '日本語',
    fr: 'Français',
    it: 'Italiano',
  },
  verification: {
    title: 'Verifizierung von Kampagnenwerbeflächen',
    subtitle: 'Laden Sie Beweisfotos für Ihre aktiven Kampagnenwerbeflächen hoch, die auf Verifizierung warten. Alle Werbeflächen einer Kampagne müssen verifiziert sein, bevor die Kampagnenzahlung freigegeben wird.',
    empty: 'Keine ausstehenden Verifizierungen',
    emptyDesc: 'Alle Ihre aktiven Kampagnenwerbeflächen sind auf dem neuesten Stand. Prüfen Sie erneut, sobald Ihre Kampagnen live sind.',
    uploadProof: 'Beweisfoto hochladen',
    uploaded: 'Nachweis eingereicht',
    uploadSuccess: 'Beweisfoto erfolgreich eingereicht.',
    noName: 'Kampagnenwerbefläche',
    locating: 'Wird lokalisiert…',
    awaitingVerification: 'Verifizierung ausstehend',
    verified: 'Verifiziert',
    partiallyVerified: 'Teilweise verifiziert',
    backToCampaigns: 'Zurück zu den Kampagnen',
    noOutdoors: 'Keine Werbeflächen für diese Kampagne gefunden',
    pendingCount: '{{count}} ausstehend',
    notYetAvailable: 'Verifizierung verfügbar ab {{date}}',
    viewProof: 'Beweisfoto anzeigen',
    proofAlt: 'Beweisfoto',
    deleteProof: 'Beweisfoto löschen',
    deleteProofSuccess: 'Beweisfoto gelöscht.',
    deleteProofConfirm: 'Möchten Sie dieses Beweisfoto wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  },
  howItWorksPage: {
    title: 'So Funktioniert Es',
    subtitle: 'Ob Sie Außenwerbeflächen besitzen oder neue Zielgruppen erreichen möchten - Scapow macht es einfach.',
    advertiserTab: 'Für Werbetreibende',
    ppTab: 'Für Flächenanbieter',
    advertiserTitle: 'Erreichen Sie Ihre Zielgruppe in großem Maßstab',
    advertiserSubtitle: 'Planen, starten und verfolgen Sie Außenwerbekampagnen - alles auf einer intuitiven Plattform.',
    adStep1Title: 'Die richtigen Flächen entdecken',
    adStep1Desc: 'Durchsuchen Sie Tausende geprüfter Außenstandorte auf einer interaktiven Karte. Filtern Sie nach Stadt, Format, Größe, Verfügbarkeit und Tagesrate, um die perfekten Standorte für Ihre Kampagne zu finden.',
    adStep2Title: 'Ihre Kampagne aufbauen',
    adStep2Desc: 'Wählen Sie mehrere Außenwerbeflächen aus und fassen Sie sie zu einer einzigen Kampagne zusammen. Legen Sie Ihre Laufzeiten fest, laden Sie Ihre Werbemittel hoch und bestätigen Sie Ihren Plan - ganz ohne Agentur.',
    adStep3Title: 'Sicher bezahlen',
    adStep3Desc: 'Erhalten Sie eine transparente Kostenaufstellung, bevor Sie sich festlegen. Bezahlen Sie sicher über unsere Plattform und ein sicheres Zahlungs-Gateway, und erhalten Sie eine offizielle Rechnung - alles dokumentiert und nachvollziehbar.',
    adStep4Title: 'Jede Platzierung verfolgen',
    adStep4Desc: 'Sobald Ihre Kampagne live ist, übermitteln die Flächenanbieter einen Fotonachweis des Außenwerbemittels. Verfolgen Sie den Status und Bestätigungen direkt in Ihrem Dashboard.',
    ppTitle: 'Verwandeln Sie Ihre Flächen in Einnahmen',
    ppSubtitle: 'Einmal listen, Tausende von Werbetreibenden erreichen und in Ihrem eigenen Tempo verdienen.',
    ppStep1Title: 'Ihre Flächen listen',
    ppStep1Desc: 'Erstellen Sie detaillierte Einträge für jeden Ihrer Außenstandorte. Fügen Sie Abmessungen, Fotos, Preise und Verfügbarkeit hinzu. Je vollständiger Ihr Eintrag, desto mehr Kampagnen ziehen Sie an.',
    ppStep2Title: 'Kampagnen zugeordnet werden',
    ppStep2Desc: 'Ihre Flächen erscheinen automatisch in den Suchanfragen von Werbetreibenden. Wenn Sie für eine Kampagne ausgewählt werden, erhalten Sie eine Benachrichtigung und eine bestätigte Buchung - ganz ohne Verhandlung.',
    ppStep3Title: 'Nachweisfotos hochladen',
    ppStep3Desc: 'Sobald Ihre Außenwerbefläche die Kampagne zeigt, laden Sie ein Nachweisfoto über die Plattform hoch. Dies ist Ihre Lieferbestätigung - und löst den Zahlungsprozess aus.',
    ppStep4Title: 'Bezahlt werden',
    ppStep4Desc: 'Sobald der Nachweis für alle Außenwerbeflächen einer Kampagne eingereicht wurde, wird die Zahlung gemäß den vereinbarten Bedingungen freigegeben. Alle Ihre Standorte der Kampagne müssen verifiziert sein, bevor die Zahlung verarbeitet wird - vollständige Lieferung wird vor der Auszahlung sichergestellt.',
    ctaTitle: 'Bereit loszulegen?',
    ctaSubtitle: 'Schließen Sie sich Tausenden von Unternehmen an, die bereits mit Scapow wachsen.',
    ctaAdvertiser: 'Werbung schalten',
    ctaProvider: 'Meine Flächen listen',
  },
  brand: {
    slogan: "it's ooh good!",
  },
  missionPage: {
    title: 'Unsere Mission',
    subtitle: 'Den Außenwerbermarkt verbinden - damit jede Fläche Wirkung erzeugt und jede Kampagne ihr Publikum findet.',
    coreTitle: 'Was Uns Antreibt',
    coreDesc: 'Die Außenwerbebranche ist fragmentiert. Großartige Flächen bleiben ungebucht. Kampagnen bleiben hinter ihrem Potenzial zurück. Wir glauben, dass Technologie das ändern kann - und Scapow ist der Weg dorthin.',
    pillar1Title: 'Reichweite und Wirkung verstärken',
    pillar1Desc: 'Wir ermöglichen Werbetreibenden, wirkungsstarke Außenwerbekampagnen über mehrere Standorte hinweg von einer einzigen Plattform aus zu planen und durchzuführen - in großem Maßstab ohne operativen Mehraufwand.',
    pillar2Title: 'Einnahmen der Anbieter maximieren',
    pillar2Desc: 'Wir geben Flächenanbietern direkten Zugang zu einem qualifizierten Pool von Werbenachfrage, reduzieren unbesetzte Inventarflächen und stellen sicher, dass ihre Flächen konstante, planbare Einnahmen erzielen.',
    pillar3Title: 'Den statischen OOH-Markt verbinden',
    pillar3Desc: 'Wir bauen die Infrastruktur auf, die die Außenwerbebranche schon lange gebraucht hat - einen transparenten, digital-first Marktplatz, auf dem Angebot und Nachfrage effizient, fair und in großem Maßstab zusammenkommen.',
    pillar4Title: 'Vertrauen durch Transparenz',
    pillar4Desc: 'Von der Überprüfung von Unternehmensnachweisen bis hin zum Fotobeweis der Werbeschaltung - jeder Schritt des Scapow-Prozesses ist so gestaltet, dass er überprüfbar, verantwortungsvoll und auf gegenseitigem Vertrauen aller Beteiligten aufgebaut ist.',
    visionTitle: 'Unsere Vision',
    visionDesc: 'Eine Welt, in der jede Außenwerbefläche eine Chance ist - und jede Marke ihre perfekte Leinwand findet, wo immer ihre Zielgruppe lebt, arbeitet und sich bewegt.',
    closingTitle: 'Die Zukunft des OOH gestalten',
    closingDesc: 'Scapow ist mehr als ein Marktplatz. Es ist das Bindegewebe der Außenwerbebranche - das Flächenanbieter, Werbetreibende und die Technologie zusammenführt, die ihren gemeinsamen Erfolg antreibt.',
  },
  contact: {
    label: 'Kontakt aufnehmen',
    title: 'Kontakt',
    subtitle: 'Haben Sie eine Frage, Feedback oder möchten Sie einfach Hallo sagen? Wir freuen uns von Ihnen zu hören.',
    infoTitle: 'Sprechen wir',
    infoDesc: 'Ob Funktionen, Preise oder etwas anderes - unser Team ist bereit, alle Ihre Fragen zu beantworten.',
    responseTimeTitle: 'Schnelle Antwort',
    responseTimeDesc: 'Wir antworten in der Regel innerhalb von 24 Stunden.',
    emailTitle: 'E-Mail senden',
    whatsappTitle: 'WhatsApp',
    formTitle: 'Nachricht senden',
    fieldName: 'Ihr Name',
    fieldEmail: 'Ihre E-Mail',
    fieldSubject: 'Betreff',
    fieldMessage: 'Nachricht',
    namePlaceholder: 'Max Mustermann',
    emailPlaceholder: 'sie@beispiel.de',
    subjectPlaceholder: 'Wie können wir helfen?',
    messagePlaceholder: 'Teilen Sie uns mit, was Sie beschäftigt…',
    submit: 'Nachricht senden',
    submitting: 'Wird gesendet…',
    successTitle: 'Nachricht gesendet!',
    successDesc: 'Vielen Dank für Ihre Kontaktaufnahme. Wir melden uns in Kürze bei Ihnen.',
    backHome: 'Zurück zur Startseite',
    errorRequired: 'Dieses Feld ist erforderlich.',
    errorEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  },
  calendar: {
    calendarMonthsHint: 'Buchbar in ganzen Kalendermonaten, vom 1. bis zum letzten Tag. Klicken Sie auf einen 1. zum Starten, auf einen späteren Tag, um dessen Monat hinzuzufügen, oder in die Buchung, um sie zu verkürzen.',
    startOnMonthFirstHint: 'Buchungen beginnen am 1. eines Monats.',
    fullMonthHint: 'Monatsweise Buchung: Wählen Sie einen Starttag und klicken Sie auf einen späteren Tag, um Monate hinzuzufügen - jeder endet am selben Tag des Folgemonats (bei Start am 1. am letzten Tag des Monats). Klicken Sie in die Buchung, um sie zu verkürzen.',
    discountsTitle: 'Länger buchen, mehr sparen',
    discountTier: 'ab {{days}} Tagen',
    discountsPickStart: 'Wählen Sie ein Startdatum, um zu sehen, welche Enddaten rabattiert sind.',
    discountsHighlighted: 'Je dunkler das Grün, desto höher der Rabatt - die Markierungen zeigen, wo jeder beginnt.',
    discountApplied: '{{percentage}} % Rabatt für diese {{count}} Tage',
    discountNextTier: '{{days}} Tag(e) mehr buchen und {{percentage}} % sparen',
    latestStartInfo: 'Startdatum bis {{date}}',
    blockedLegend: 'Blockiert / nicht verfügbar',
    pendingLegend: 'Ausstehend (noch nicht gespeichert)',
    loading: 'Verfügbarkeit wird geladen…',
    noticeRequired: 'Frühestes Startdatum: {{date}} ({{count}} Tage Vorlaufzeit erforderlich)',
    minimumDaysError: 'Mindestmietdauer {{count}} Tage - bitte Auswahl verlängern',
    overlapError: 'Der gewählte Zeitraum überschneidet reservierte Daten - bitte nur aufeinanderfolgende freie Tage wählen',
  },
  approvals: {
    thisBookingLegend: 'Diese Buchung',
    blockedSelection: 'Gesperrter Zeitraum:',
    blockedSelectionEmpty: 'Wählen Sie Start- und Enddatum im Kalender.',
    title: 'Freigaben',
    subtitle: 'Bestätigen Sie, ob Ihre Standorte für diese bezahlten Kampagnen verfügbar sind.',
    emptyTitle: 'Alles erledigt',
    emptyDesc: 'Wenn ein Werbetreibender einen Ihrer Standorte bucht, erscheint er hier zur Freigabe.',
    campaignFallback: 'Kampagne',
    outdoorsToReview: 'Zu prüfende Standorte: {{count}}',
    startsOn: 'Beginnt am {{date}}',
    answerBy: 'Antworten bis {{date}}',
    review: 'Prüfen',
    youEarn: 'Sie verdienen',
    backToList: 'Zurück zu den Freigaben',
    reviewEyebrow: 'Freigabeanfrage',
    summaryLine: 'Standorte: {{count}} · Sie verdienen {{value}}',
    deadlineNotice: 'Bitte antworten Sie bis {{date}}. Nicht rechtzeitig beantwortete Standorte werden aus der Kampagne entfernt.',
    progress: '{{answered}} von {{total}} beantwortet',
    approveAll: 'Alle freigeben',
    available: 'Verfügbar',
    unavailable: 'Nicht verfügbar',
    decisionFor: 'Ist {{name}} verfügbar?',
    decisionRequired: 'Bitte wählen Sie eine Antwort.',
    blockedHint: 'Geben Sie an, wann dieser Standort bereits belegt ist - wir sperren diese Termine.',
    blockedFrom: 'Gesperrt ab',
    blockedTo: 'Gesperrt bis',
    blockedRequired: 'Beide Daten sind erforderlich.',
    blockedOrder: 'Das Enddatum muss am oder nach dem Startdatum liegen.',
    viewCreative: 'Werbemittel für {{name}} ansehen',
    noCreative: 'Noch kein Werbemittel',
    feedbackMandatory: 'Für jeden Standort ist eine Antwort nötig.',
    submit: 'Antworten senden',
    fixBeforeSubmit: 'Bitte beantworten Sie jeden Standort und prüfen Sie die gesperrten Termine.',
    confirmTitle: 'Antworten senden?',
    confirmSummary: 'Verfügbar: {{approved}} · Nicht verfügbar: {{unavailable}}',
    confirmNote: 'Antworten können nach dem Senden nicht mehr geändert werden.',
    submitted: 'Danke - Ihre Antworten wurden gesendet.',
    submitError: 'Ihre Antworten konnten nicht gesendet werden.',
    allAnsweredTitle: 'Bereits beantwortet',
    allAnsweredDesc: 'Sie haben für alle Ihre Standorte in dieser Kampagne geantwortet.',
    loadErrorTitle: 'Diese Freigabe ist nicht verfügbar',
    loadErrorDesc: 'Sie wurde womöglich schon beantwortet, oder die Kampagne wurde storniert.',
  },
  status: {
    installment: {
      SCHEDULED: 'Geplant',
      PROCESSING: 'In Bearbeitung',
      PAID: 'Bezahlt',
      FAILED: 'Fehlgeschlagen',
      CANCELLED: 'Storniert',
    },
    campaign: {
      PENDING: 'Entwurf',
      AWAITING_PAYMENT: 'Zahlung ausstehend',
      CONFIRMING: 'Wartet auf Anbieter',
      AWAITING_CONFIRMATION: 'Entscheidung nötig',
      READY: 'Bestätigt',
      RUNNING: 'Live',
      COMPLETED: 'Abgeschlossen',
      CANCELLED: 'Storniert',
      UNAVAILABLE: 'Nicht verfügbar',
    },
    payment: {
      PENDING: 'Nicht bezahlt',
      VALIDATING_PAYMENT: 'Zahlung wird geprüft',
      MANUAL_VALIDATION: 'In Prüfung',
      TRANSFER_REQUESTED: 'Überweisung angefordert',
      PAID: 'Bezahlt',
      CANCELLED: 'Storniert',
      PARTIALLY_REFUNDED: 'Teilweise erstattet',
      FULLY_REFUNDED: 'Erstattet',
      FAILED: 'Fehlgeschlagen',
    },
    campaignOutdoor: {
      PENDING: 'Nachweis ausstehend',
      VERIFYING: 'Nachweis wird geprüft',
      FOR_MANUAL_APPROVAL: 'Nachweis in Prüfung',
      APPROVED: 'Nachweis freigegeben',
      REJECTED: 'Nachweis abgelehnt',
      REFUNDED: 'Erstattet',
      CANCELLED: 'Storniert',
    },
    proof: {
      PENDING: 'Ausstehend',
      VALID: 'Gültig',
      MANUAL_VALIDATION: 'In Prüfung',
      INVALID: 'Ungültig',
    },
    paymentType: {
      BUYING_ADS: 'Werbekauf',
      SELLING_ADS: 'Auszahlung an Anbieter',
      REFUND_BUYING_PART: 'Erstattung an Werbetreibende',
      REFUND_SELLING_PART: 'Erstattung des Anbieters',
      PLACEMENT_PROVIDER_DEBT: 'Schuld des Anbieters',
      PLACEMENT_PROVIDER_CANCELLATION_FEE: 'Stornoentschädigung',
    },
  },
  offlineCampaigns: {
    creativesTitle: 'Werbemittel',
    creativesSubtitle: 'Motive zum Anbringen. Jede Größe ist möglich - Sie entscheiden, wie sie zu jedem Standort passen.',
    uploadCreatives: 'Werbemittel hochladen',
    noCreatives: 'Noch keine Werbemittel. Klicken Sie, um JPG-, PNG-, TIFF- oder PDF-Dateien hochzuladen.',
    creativesUploaded: 'Werbemittel hochgeladen.',
    creativeRemoved: 'Werbemittel entfernt.',
    removeCreative: 'Werbemittel entfernen',
    removeCreativeConfirm: 'Dieses Werbemittel entfernen? Dies kann nicht rückgängig gemacht werden.',
    downloadOriginal: 'Original herunterladen',
    filesTitle: 'Dateien',
    filesSubtitle: 'Verträge, Briefings oder andere Dateien zu dieser Kampagne.',
    uploadFiles: 'Dateien hochladen',
    noFiles: 'Noch keine Dateien hochgeladen.',
    filesUploaded: 'Dateien hochgeladen.',
    fileRemoved: 'Datei entfernt.',
    removeFile: 'Datei entfernen',
    removeFileConfirm: '„{{name}}“ entfernen? Dies kann nicht rückgängig gemacht werden.',
    download: 'Herunterladen',
    remove: 'Entfernen',
    outdoorsTitle: 'Standorte',
    noOutdoors: 'Diese Kampagne hat noch keine Standorte.',
    modalTitle: 'Zu einer Offline-Kampagne hinzufügen',
    newTitle: 'Neue Offline-Kampagne',
    pickTitle: 'Offline-Kampagne auswählen',
    datesTitle: 'Termine wählen',
    doneTitle: 'Standort hinzugefügt',
    forOutdoor: 'Standort:',
    optionNew: 'Neu',
    optionNewDesc: 'Legen Sie eine Kampagne für eine außerhalb von Scapow verkaufte Buchung an.',
    optionPick: 'Bestehende wählen',
    optionPickDesc: 'Fügen Sie ihn einer Ihrer Offline-Kampagnen hinzu.',
    name: 'Kampagnenname',
    nameRequired: 'Geben Sie der Kampagne einen Namen.',
    details: 'Details',
    detailsHint: 'Z. B. der Kunde oder Vertriebskanal.',
    notes: 'Notizen',
    notesHint: 'Interne Notizen - nur für Ihr Team sichtbar.',
    instructions: 'Anweisungen',
    instructionsHint: 'Für die Person, die das Werbemittel anbringt.',
    createAndContinue: 'Erstellen und weiter',
    createError: 'Die Offline-Kampagne konnte nicht erstellt werden.',
    addError: 'Der Standort konnte der Kampagne nicht hinzugefügt werden.',
    noneYet: 'Sie haben noch keine Offline-Kampagnen.',
    outdoorsCount: 'Standorte: {{count}}',
    createdOn: 'erstellt am {{date}}',
    datesIntro: 'Wählen Sie, wann der Standort für „{{campaign}}“ gebucht ist. Bereits belegte Termine werden angezeigt und sind nicht wählbar.',
    pickDates: 'Wählen Sie Start- und Enddatum im Kalender.',
    addToCampaign: 'Zur Kampagne hinzufügen',
    doneMessage: '{{outdoor}} wurde zu „{{campaign}}“ hinzugefügt.',
    doneHint: 'Diese Termine sind jetzt für andere Buchungen gesperrt.',
    backToSearch: 'Zurück zur Suche',
    getAvailability: 'Verfügbarkeit prüfen',
    clearAvailability: 'Verfügbarkeit zurücksetzen',
    availabilityTitle: 'Verfügbarkeit prüfen',
    availabilityHint: 'Wählen Sie Start- und Enddatum, um nur die Standorte zu sehen, die im gesamten Zeitraum frei sind.',
    showAvailable: 'Verfügbare Standorte anzeigen',
    dimensionsLabel: 'Größen',
    noMatches: 'Keine Standorte passen zu diesen Filtern',
    noMatchesHint: 'Versuchen Sie andere Größen oder Termine oder setzen Sie die Filter zurück.',
    clearFilters: 'Filter zurücksetzen',
    addButton: 'Zu Offline-Kampagne hinzufügen',
    addTooltip: 'Zu einer nicht über Scapow gebuchten Kampagne hinzufügen',
  },
};

export default de;
